/**
 * @module avast.web.balloon
 * Toggle balloons
 * @author <gabriel@avast.com>`
 * @version 0.0.1
 */

(function(){
	avm.define('avast.web.balloon', function(){
		var $ = avm.require('jquery');

		$('.js-balloon-trigger').on('mouseover', function(evt){
			var target = evt.currentTarget;

			$(target).next('.js-balloon').removeClass('hidden')
		});

		$('.js-balloon-trigger').on('mouseout', function(evt){
			var target = evt.currentTarget;

			$(target).next('.js-balloon').addClass('hidden')
		});
	});

	/**
	 * @module avast.web.getGeoData
 	 * @author <gabriel@avast.com>`
 	 * @version 0.0.1
   */

	avm.define('avast.web.getGeoData', function(ip, city, isp){
		var $ = avm.require('jquery'),
				capitalizeFirstLetter = function (string) {
					return string.charAt(0).toUpperCase() + string.slice(1);
				}


			return $.ajax({
					url: 'antitrack-data'
					}).done(function(data) {
						var _data = JSON.parse(data);

						$(city).text(capitalizeFirstLetter(_data.city));
						$(isp).text(capitalizeFirstLetter(_data.isp));
						$(ip).text(capitalizeFirstLetter(_data.ip));
			});
	});

	// Get geoip data from ajax request
	avm.require('avast.web.getGeoData')('.js-ip', '.js-location')

	// Init ballons
	avm.require('avast.web.balloon')();


	// FAQ toggler
	var $infoBox = $('.js-question');

	if ( $infoBox.length > 0 ) {
		$infoBox.on('click', function() {
			var $self = $(this),
				$target = $self,
				targetOpened = !!$target.hasClass('expand');

			// Close all boxes
			$infoBox.removeClass('expand');

			// Check current box for toggle
			if (targetOpened) {
				$target.removeClass('expand');
			} else {
				$target.addClass('expand');
			}
		});
	}
})();

/*!
 * Joseph Myer's md5() algorithm wrapped in a self-invoked function to prevent
 * global namespace polution, modified to hash unicode characters as UTF-8.
 *
 * Copyright 1999-2010, Joseph Myers, Paul Johnston, Greg Holt, Will Bond <will@wbond.net>
 * http://www.myersdaily.org/joseph/javascript/md5-text.html
 * http://pajhome.org.uk/crypt/md5
 *
 * Released under the BSD license
 * http://www.opensource.org/licenses/bsd-license
 */
(function() {
	function md5cycle(x, k) {
		var a = x[0], b = x[1], c = x[2], d = x[3];

		a = ff(a, b, c, d, k[0], 7, -680876936);
		d = ff(d, a, b, c, k[1], 12, -389564586);
		c = ff(c, d, a, b, k[2], 17, 606105819);
		b = ff(b, c, d, a, k[3], 22, -1044525330);
		a = ff(a, b, c, d, k[4], 7, -176418897);
		d = ff(d, a, b, c, k[5], 12, 1200080426);
		c = ff(c, d, a, b, k[6], 17, -1473231341);
		b = ff(b, c, d, a, k[7], 22, -45705983);
		a = ff(a, b, c, d, k[8], 7, 1770035416);
		d = ff(d, a, b, c, k[9], 12, -1958414417);
		c = ff(c, d, a, b, k[10], 17, -42063);
		b = ff(b, c, d, a, k[11], 22, -1990404162);
		a = ff(a, b, c, d, k[12], 7, 1804603682);
		d = ff(d, a, b, c, k[13], 12, -40341101);
		c = ff(c, d, a, b, k[14], 17, -1502002290);
		b = ff(b, c, d, a, k[15], 22, 1236535329);

		a = gg(a, b, c, d, k[1], 5, -165796510);
		d = gg(d, a, b, c, k[6], 9, -1069501632);
		c = gg(c, d, a, b, k[11], 14, 643717713);
		b = gg(b, c, d, a, k[0], 20, -373897302);
		a = gg(a, b, c, d, k[5], 5, -701558691);
		d = gg(d, a, b, c, k[10], 9, 38016083);
		c = gg(c, d, a, b, k[15], 14, -660478335);
		b = gg(b, c, d, a, k[4], 20, -405537848);
		a = gg(a, b, c, d, k[9], 5, 568446438);
		d = gg(d, a, b, c, k[14], 9, -1019803690);
		c = gg(c, d, a, b, k[3], 14, -187363961);
		b = gg(b, c, d, a, k[8], 20, 1163531501);
		a = gg(a, b, c, d, k[13], 5, -1444681467);
		d = gg(d, a, b, c, k[2], 9, -51403784);
		c = gg(c, d, a, b, k[7], 14, 1735328473);
		b = gg(b, c, d, a, k[12], 20, -1926607734);

		a = hh(a, b, c, d, k[5], 4, -378558);
		d = hh(d, a, b, c, k[8], 11, -2022574463);
		c = hh(c, d, a, b, k[11], 16, 1839030562);
		b = hh(b, c, d, a, k[14], 23, -35309556);
		a = hh(a, b, c, d, k[1], 4, -1530992060);
		d = hh(d, a, b, c, k[4], 11, 1272893353);
		c = hh(c, d, a, b, k[7], 16, -155497632);
		b = hh(b, c, d, a, k[10], 23, -1094730640);
		a = hh(a, b, c, d, k[13], 4, 681279174);
		d = hh(d, a, b, c, k[0], 11, -358537222);
		c = hh(c, d, a, b, k[3], 16, -722521979);
		b = hh(b, c, d, a, k[6], 23, 76029189);
		a = hh(a, b, c, d, k[9], 4, -640364487);
		d = hh(d, a, b, c, k[12], 11, -421815835);
		c = hh(c, d, a, b, k[15], 16, 530742520);
		b = hh(b, c, d, a, k[2], 23, -995338651);

		a = ii(a, b, c, d, k[0], 6, -198630844);
		d = ii(d, a, b, c, k[7], 10, 1126891415);
		c = ii(c, d, a, b, k[14], 15, -1416354905);
		b = ii(b, c, d, a, k[5], 21, -57434055);
		a = ii(a, b, c, d, k[12], 6, 1700485571);
		d = ii(d, a, b, c, k[3], 10, -1894986606);
		c = ii(c, d, a, b, k[10], 15, -1051523);
		b = ii(b, c, d, a, k[1], 21, -2054922799);
		a = ii(a, b, c, d, k[8], 6, 1873313359);
		d = ii(d, a, b, c, k[15], 10, -30611744);
		c = ii(c, d, a, b, k[6], 15, -1560198380);
		b = ii(b, c, d, a, k[13], 21, 1309151649);
		a = ii(a, b, c, d, k[4], 6, -145523070);
		d = ii(d, a, b, c, k[11], 10, -1120210379);
		c = ii(c, d, a, b, k[2], 15, 718787259);
		b = ii(b, c, d, a, k[9], 21, -343485551);

		x[0] = add32(a, x[0]);
		x[1] = add32(b, x[1]);
		x[2] = add32(c, x[2]);
		x[3] = add32(d, x[3]);
	}

	function cmn(q, a, b, x, s, t) {
		a = add32(add32(a, q), add32(x, t));
		return add32((a << s) | (a >>> (32 - s)), b);
	}

	function ff(a, b, c, d, x, s, t) {
		return cmn((b & c) | ((~b) & d), a, b, x, s, t);
	}

	function gg(a, b, c, d, x, s, t) {
		return cmn((b & d) | (c & (~d)), a, b, x, s, t);
	}

	function hh(a, b, c, d, x, s, t) {
		return cmn(b ^ c ^ d, a, b, x, s, t);
	}

	function ii(a, b, c, d, x, s, t) {
		return cmn(c ^ (b | (~d)), a, b, x, s, t);
	}

	function md51(s) {
		// Converts the string to UTF-8 "bytes" when necessary
		if (/[\x80-\xFF]/.test(s)) {
			s = unescape(encodeURI(s));
		}
		txt = '';
		var n = s.length, state = [1732584193, -271733879, -1732584194, 271733878], i;
		for (i = 64; i <= s.length; i += 64) {
			md5cycle(state, md5blk(s.substring(i - 64, i)));
		}
		s = s.substring(i - 64);
		var tail = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
		for (i = 0; i < s.length; i++)
		tail[i >> 2] |= s.charCodeAt(i) << ((i % 4) << 3);
		tail[i >> 2] |= 0x80 << ((i % 4) << 3);
		if (i > 55) {
			md5cycle(state, tail);
			for (i = 0; i < 16; i++) tail[i] = 0;
		}
		tail[14] = n * 8;
		md5cycle(state, tail);
		return state;
	}

	function md5blk(s) { /* I figured global was faster.   */
		var md5blks = [], i; /* Andy King said do it this way. */
		for (i = 0; i < 64; i += 4) {
			md5blks[i >> 2] = s.charCodeAt(i) +
			                  (s.charCodeAt(i + 1) << 8) +
			                  (s.charCodeAt(i + 2) << 16) +
			                  (s.charCodeAt(i + 3) << 24);
		}
		return md5blks;
	}

	var hex_chr = '0123456789abcdef'.split('');

	function rhex(n) {
		var s = '', j = 0;
		for (; j < 4; j++)
		s += hex_chr[(n >> (j * 8 + 4)) & 0x0F] +
		     hex_chr[(n >> (j * 8)) & 0x0F];
		return s;
	}

	function hex(x) {
		for (var i = 0; i < x.length; i++)
		x[i] = rhex(x[i]);
		return x.join('');
	}

	md5 = function (s) {
		return hex(md51(s));
	}

	/* this function is much faster, so if possible we use it. Some IEs are the
	only ones I know of that need the idiotic second function, generated by an
	if clause.  */
	function add32(a, b) {
		return (a + b) & 0xFFFFFFFF;
	}

	if (md5('hello') != '5d41402abc4b2a76b9719d911017c592') {
		function add32(x, y) {
			var lsw = (x & 0xFFFF) + (y & 0xFFFF),
			    msw = (x >> 16) + (y >> 16) + (lsw >> 16);
			return (msw << 16) | (lsw & 0xFFFF);
		}
	}
})();



/*
* fingerprintJS 0.5.5 - Fast browser fingerprint library
*/
;(function (name, context, definition) {
	if (typeof module !== 'undefined' && module.exports) { module.exports = definition(); }
	else if (typeof define === 'function' && define.amd) { define(definition); }
	else { context[name] = definition(); }
  })('Fingerprint', this, function () {
	'use strict';

	var Fingerprint = function (options) {
	  var nativeForEach, nativeMap;
	  nativeForEach = Array.prototype.forEach;
	  nativeMap = Array.prototype.map;

	  this.each = function (obj, iterator, context) {
		if (obj === null) {
		  return;
		}
		if (nativeForEach && obj.forEach === nativeForEach) {
		  obj.forEach(iterator, context);
		} else if (obj.length === +obj.length) {
		  for (var i = 0, l = obj.length; i < l; i++) {
			if (iterator.call(context, obj[i], i, obj) === {}) return;
		  }
		} else {
		  for (var key in obj) {
			if (obj.hasOwnProperty(key)) {
			  if (iterator.call(context, obj[key], key, obj) === {}) return;
			}
		  }
		}
	  };

	  this.map = function(obj, iterator, context) {
		var results = [];
		// Not using strict equality so that this acts as a
		// shortcut to checking for `null` and `undefined`.
		if (obj == null) return results;
		if (nativeMap && obj.map === nativeMap) return obj.map(iterator, context);
		this.each(obj, function(value, index, list) {
		  results[results.length] = iterator.call(context, value, index, list);
		});
		return results;
	  };

	  if (typeof options == 'object'){
		this.hasher = options.hasher;
		this.screen_resolution = options.screen_resolution;
		this.screen_orientation = options.screen_orientation;
		this.canvas = options.canvas;
		this.ie_activex = options.ie_activex;
	  } else if(typeof options == 'function'){
		this.hasher = options;
	  }
	};

	Fingerprint.prototype = {
	  get: function(){
		var keys = [];
		keys.push(navigator.userAgent);
		keys.push(navigator.language);
		keys.push(screen.colorDepth);
		if (this.screen_resolution) {
		  var resolution = this.getScreenResolution();
		  if (typeof resolution !== 'undefined'){ // headless browsers, such as phantomjs
			keys.push(resolution.join('x'));
		  }
		}
		keys.push(new Date().getTimezoneOffset());
		keys.push(this.hasSessionStorage());
		keys.push(this.hasLocalStorage());
		keys.push(this.hasIndexDb());
		//body might not be defined at this point or removed programmatically
		if(document.body){
		  keys.push(typeof(document.body.addBehavior));
		} else {
		  keys.push(typeof undefined);
		}
		keys.push(typeof(window.openDatabase));
		keys.push(navigator.cpuClass);
		keys.push(navigator.platform);
		keys.push(navigator.doNotTrack);
		keys.push(this.getPluginsString());
		if(this.canvas && this.isCanvasSupported()){
		  keys.push(this.getCanvasFingerprint());
		}
		if(this.hasher){
		  return this.hasher(keys.join('###'), 31);
		} else {
		  return this.murmurhash3_32_gc(keys.join('###'), 31);
		}
	  },

	  /**
	   * JS Implementation of MurmurHash3 (r136) (as of May 20, 2011)
	   *
	   * @author <a href="mailto:gary.court@gmail.com">Gary Court</a>
	   * @see http://github.com/garycourt/murmurhash-js
	   * @author <a href="mailto:aappleby@gmail.com">Austin Appleby</a>
	   * @see http://sites.google.com/site/murmurhash/
	   *
	   * @param {string} key ASCII only
	   * @param {number} seed Positive integer only
	   * @return {number} 32-bit positive integer hash
	   */

	  murmurhash3_32_gc: function(key, seed) {
		var remainder, bytes, h1, h1b, c1, c2, k1, i;

		remainder = key.length & 3; // key.length % 4
		bytes = key.length - remainder;
		h1 = seed;
		c1 = 0xcc9e2d51;
		c2 = 0x1b873593;
		i = 0;

		while (i < bytes) {
			k1 =
			  ((key.charCodeAt(i) & 0xff)) |
			  ((key.charCodeAt(++i) & 0xff) << 8) |
			  ((key.charCodeAt(++i) & 0xff) << 16) |
			  ((key.charCodeAt(++i) & 0xff) << 24);
		  ++i;

		  k1 = ((((k1 & 0xffff) * c1) + ((((k1 >>> 16) * c1) & 0xffff) << 16))) & 0xffffffff;
		  k1 = (k1 << 15) | (k1 >>> 17);
		  k1 = ((((k1 & 0xffff) * c2) + ((((k1 >>> 16) * c2) & 0xffff) << 16))) & 0xffffffff;

		  h1 ^= k1;
			  h1 = (h1 << 13) | (h1 >>> 19);
		  h1b = ((((h1 & 0xffff) * 5) + ((((h1 >>> 16) * 5) & 0xffff) << 16))) & 0xffffffff;
		  h1 = (((h1b & 0xffff) + 0x6b64) + ((((h1b >>> 16) + 0xe654) & 0xffff) << 16));
		}

		k1 = 0;

		switch (remainder) {
		  case 3: k1 ^= (key.charCodeAt(i + 2) & 0xff) << 16;
		  case 2: k1 ^= (key.charCodeAt(i + 1) & 0xff) << 8;
		  case 1: k1 ^= (key.charCodeAt(i) & 0xff);

		  k1 = (((k1 & 0xffff) * c1) + ((((k1 >>> 16) * c1) & 0xffff) << 16)) & 0xffffffff;
		  k1 = (k1 << 15) | (k1 >>> 17);
		  k1 = (((k1 & 0xffff) * c2) + ((((k1 >>> 16) * c2) & 0xffff) << 16)) & 0xffffffff;
		  h1 ^= k1;
		}

		h1 ^= key.length;

		h1 ^= h1 >>> 16;
		h1 = (((h1 & 0xffff) * 0x85ebca6b) + ((((h1 >>> 16) * 0x85ebca6b) & 0xffff) << 16)) & 0xffffffff;
		h1 ^= h1 >>> 13;
		h1 = ((((h1 & 0xffff) * 0xc2b2ae35) + ((((h1 >>> 16) * 0xc2b2ae35) & 0xffff) << 16))) & 0xffffffff;
		h1 ^= h1 >>> 16;

		return h1 >>> 0;
	  },

	  // https://bugzilla.mozilla.org/show_bug.cgi?id=781447
	  hasLocalStorage: function () {
		try{
		  return !!window.localStorage;
		} catch(e) {
		  return true; // SecurityError when referencing it means it exists
		}
	  },

	  hasSessionStorage: function () {
		try{
		  return !!window.sessionStorage;
		} catch(e) {
		  return true; // SecurityError when referencing it means it exists
		}
	  },

	  hasIndexDb: function () {
		try{
		  return !!window.indexedDB;
		} catch(e) {
		  return true; // SecurityError when referencing it means it exists
		}
	  },

	  isCanvasSupported: function () {
		var elem = document.createElement('canvas');
		return !!(elem.getContext && elem.getContext('2d'));
	  },

	  isIE: function () {
		if(navigator.appName === 'Microsoft Internet Explorer') {
		  return true;
		} else if(navigator.appName === 'Netscape' && /Trident/.test(navigator.userAgent)){// IE 11
		  return true;
		}
		return false;
	  },

	  getPluginsString: function () {
		if(this.isIE() && this.ie_activex){
		  return this.getIEPluginsString();
		} else {
		  return this.getRegularPluginsString();
		}
	  },

	  getRegularPluginsString: function () {
		return this.map(navigator.plugins, function (p) {
		  var mimeTypes = this.map(p, function(mt){
			return [mt.type, mt.suffixes].join('~');
		  }).join(',');
		  return [p.name, p.description, mimeTypes].join('::');
		}, this).join(';');
	  },

	  getIEPluginsString: function () {
		if(window.ActiveXObject){
		  var names = ['ShockwaveFlash.ShockwaveFlash',//flash plugin
			'AcroPDF.PDF', // Adobe PDF reader 7+
			'PDF.PdfCtrl', // Adobe PDF reader 6 and earlier, brrr
			'QuickTime.QuickTime', // QuickTime
			// 5 versions of real players
			'rmocx.RealPlayer G2 Control',
			'rmocx.RealPlayer G2 Control.1',
			'RealPlayer.RealPlayer(tm) ActiveX Control (32-bit)',
			'RealVideo.RealVideo(tm) ActiveX Control (32-bit)',
			'RealPlayer',
			'SWCtl.SWCtl', // ShockWave player
			'WMPlayer.OCX', // Windows media player
			'AgControl.AgControl', // Silverlight
			'Skype.Detection'];

		  // starting to detect plugins in IE
		  return this.map(names, function(name){
			try{
			  new ActiveXObject(name);
			  return name;
			} catch(e){
			  return null;
			}
		  }).join(';');
		} else {
		  return ""; // behavior prior version 0.5.0, not breaking backwards compat.
		}
	  },

	  getScreenResolution: function () {
		var resolution;
		 if(this.screen_orientation){
		   resolution = (screen.height > screen.width) ? [screen.height, screen.width] : [screen.width, screen.height];
		 }else{
		   resolution = [screen.height, screen.width];
		 }
		 return resolution;
	  },

	  getCanvasFingerprint: function () {
		var canvas = document.createElement('canvas');
		var ctx = canvas.getContext('2d');
		// https://www.browserleaks.com/canvas#how-does-it-work
		var txt = 'http://valve.github.io';
		ctx.textBaseline = "top";
		ctx.font = "14px 'Arial'";
		ctx.textBaseline = "alphabetic";
		ctx.fillStyle = "#f60";
		ctx.fillRect(125,1,62,20);
		ctx.fillStyle = "#069";
		ctx.fillText(txt, 2, 15);
		ctx.fillStyle = "rgba(102, 204, 0, 0.7)";
		ctx.fillText(txt, 4, 17);
		return canvas.toDataURL();
	  }
	};


	return Fingerprint;

  });





(function() {
	'use strict';
	var $ = avm.require('jquery'),
		$document = $(document),
		detect = avastGlobals.detect,
		isCookieEnabled = avm.require('avast.storage.isCookieEnabled'),
		$browser = $('.js-browser'),
		$cookiesEnabled = $('.js-cookies-enabled'),
		$operatingSystem = $('.js-operating-system'),
		$allowed = $cookiesEnabled.find('.js-allowed'),
		$disallowed = $cookiesEnabled.find('.js-disallowed'),
		$scanPopup = $('.js-scan-popup'),
		$scanPopupOpen = $('.js-scan-popup-open'),
		$scanPopupClose = $scanPopup.find('.js-scan-popup-close'),
		$accountsLoggedCount = $scanPopup.find('.js-accounts-logged-count'),
		$resultsContent = $scanPopup.find('.js-results-content'),
		$loadingContent = $scanPopup.find('.js-loading-content'),
		$tab = $('.js-tab'),
		$fingerprint = $scanPopup.find('.js-fingerprint'),
		fingerprint = new Fingerprint().get(),
		loaderTimeout;

	window.createjsLoaded = false;

	if (window.location.hash === '#freescan') {
		window.location.hash = '!';
	}

	// Get users fingerprint and encode to MD5
	$fingerprint.text(md5(fingerprint.toString()));

	/**
	 * @param {string} string
	 * @returns {string}
	 */
	function capitalizeFirstLetter(string) {
		return string.charAt(0).toUpperCase() + string.slice(1);
	}

	$operatingSystem.text(detect.os.name);
	$browser.text(detect.browser.name + ' ' + detect.browser.version);
	isCookieEnabled ? $allowed.removeClass('hide') : $disallowed.removeClass('hide');

	// Scan logged in applications
	var count = 0,
		progress = 0,
		$accounts = $('.js-accounts'),
		$accountsLoggedAppList = $('.js-accounts-logged-app-list'),
		$accountsLoggedProgress = $('.js-accounts-logged-progress'),
		platforms = [{
			domain: 'https://squareup.com',
			redirect: '/login?return_to=%2Ffavicon.ico',
			name: 'Square'
		}, {
			domain: 'https://twitter.com',
			redirect: '/login?redirect_after_login=%2Ffavicon.ico',
			name: 'Twitter'
		}, {
			domain: 'https://www.facebook.com',
			redirect: '/login.php?next=https%3A%2F%2Fwww.facebook.com%2Ffavicon.ico%3F_rdr%3Dp',
			name: 'Facebook'
		}, {
			domain: 'https://accounts.google.com',
			redirect: '/ServiceLogin?passive=true&continue=https%3A%2F%2Fwww.google.com%2Ffavicon.ico&uilel=3&hl=en&service=mail',
			name: 'Gmail'
		}, {
			domain: 'https://accounts.google.com',
			redirect: '/ServiceLogin?passive=true&continue=https%3A%2F%2Fwww.youtube.com%2Ffavicon.ico&uilel=3&hl=en&service=youtube',
			name: 'Youtube'
		}, {
			domain: 'https://plus.google.com',
			redirect: '/up/accounts/upgrade/?continue=https://plus.google.com/favicon.ico',
			name: 'Google Plus'
		}, {
			domain: 'https://login.skype.com',
			redirect: '/login?message=signin_continue&redirect_uri=https%3A%2F%2Fsecure.skype.com%2Ffavicon.ico',
			name: 'Skype'
		}, {
			domain: 'https://www.spotify.com',
			redirect: '/en/login/?forward_url=https%3A%2F%2Fwww.spotify.com%2Ffavicon.ico',
			name: 'Spotify'
		}, {
			domain: 'https://www.reddit.com',
			redirect: '/login?dest=https%3A%2F%2Fwww.reddit.com%2Ffavicon.ico',
			name: 'Reddit'
		}, {
			domain: 'https://www.tumblr.com',
			redirect: '/login?redirect_to=%2Ffavicon.ico',
			name: 'Tumblr'
		}, {
			domain: 'https://www.expedia.de',
			redirect: '/user/login?ckoflag=0&selc=0&uurl=qscr%3Dreds%26rurl%3D%252Ffavicon.ico',
			name: 'Expedia'
		}, {
			domain: 'https://www.dropbox.com',
			redirect: '/login?cont=https%3A%2F%2Fwww.dropbox.com%2Fstatic%2Fimages%2Fabout%2Fdropbox_logo_glyph_2015.svg',
			name: 'Dropbox'
		}, {
			domain: 'https://www.amazon.com',
			redirect: '/ap/signin/178-4417027-1316064?_encoding=UTF8&openid.assoc_handle=usflex&openid.claimed_id=http%3A%2F%2Fspecs.openid.net%2Fauth%2F2.0%2Fidentifier_select&openid.identity=http%3A%2F%2Fspecs.openid.net%2Fauth%2F2.0%2Fidentifier_select&openid.mode=checkid_setup&openid.ns=http%3A%2F%2Fspecs.openid.net%2Fauth%2F2.0&openid.ns.pape=http%3A%2F%2Fspecs.openid.net%2Fextensions%2Fpape%2F1.0&openid.pape.max_auth_age=10000000&openid.return_to=https%3A%2F%2Fwww.amazon.com%2Ffavicon.ico',
			name: 'Amazon.com'
		}, {
			domain: 'https://www.pinterest.com',
			redirect: '/login/?next=https%3A%2F%2Fwww.pinterest.com%2Ffavicon.ico',
			name: 'Pinterest'
		}, {
			domain: 'https://de.foursquare.com',
			redirect: '/login?continue=%2Ffavicon.ico',
			name: 'Foursquare'
		}, {
			domain: 'https://eu.battle.net',
			redirect: '/login/de/index?ref=http://eu.battle.net/favicon.ico',
			name: 'Battle.net'
		}, {
			domain: 'https://store.steampowered.com',
			redirect: '/login/?redir=favicon.ico',
			name: 'Steam'
		}, {
			domain: 'https://www.academia.edu',
			redirect: '/login?cp=/favicon.ico&cs=www',
			name: 'Academia.edu'
		}, {
			domain: 'https://accounts.google.com',
			redirect: '/ServiceLogin?service=blogger&hl=de&passive=1209600&continue=https://www.blogger.com/favicon.ico',
			name: 'Blogger'
		}, {
			domain: 'https://github.com',
			redirect: '/login?return_to=https%3A%2F%2Fgithub.com%2Ffavicon.ico%3Fid%3D1',
			name: 'Github'
		}, {
			domain: 'https://medium.com',
			redirect: '/m/signin?redirect=https%3A%2F%2Fmedium.com%2Ffavicon.ico&loginType=default',
			name: 'Medium'
		}, {
			domain: 'https://slack.com',
			redirect: '/checkcookie?redir=https%3A%2F%2Fslack.com%2Ffavicon.ico%23',
			name: 'Slack'
		}, {
			domain: 'https://www.paypal.com',
			redirect: '/signin?returnUri=https://t.paypal.com/ts?v=1.0.0',
			name: 'Paypal'
		}, {
			domain: 'https://500px.com',
			redirect: '/login?r=%2Ffavicon.ico',
			name: '500px'
		}, {
			domain: 'https://disqus.com',
			redirect: '/profile/login/?next=https%3A%2F%2Fdisqus.com%2Ffavicon.ico',
			name: 'Disqus'
		}, {
			domain: 'https://secure.meetup.com',
			redirect: '/login/?returnUri=https%3A%2F%2Fwww.meetup.com%2Fimg%2Fajax_loader_trans.gif',
			name: 'Meetup'
		}, {
			domain: 'https://bitbucket.org',
			redirect: '/account/signin/?next=/favicon.ico',
			name: 'BitBucket'
		}, {
			domain: 'https://secure.indeed.com',
			redirect: '/account/login?continue=%2ffavicon.ico',
			name: 'Indeed'
		}, {
			domain: 'https://vk.com',
			redirect: '/login?u=2&to=ZmF2aWNvbi5pY28-',
			name: 'VK'
		}];

	/**
	 * @param {function} callback
	 */
	function loggedAccounts(callback) {
		$(platforms).each(function(index, network) {
			var img = document.createElement('img');
			img.src = network.domain + network.redirect;
			img.onload = function() {
				$accountsLoggedCount.text(count);
				callback(network, true);
				count++;
			};
			img.onerror = function() {
				$accountsLoggedCount.text(count);
				callback(network, false);
			};
		});
	}

	var platformsCount = 29;

	/**
	 * @param {number} progress
	 */
	function updateProgress(progress) {
		var platformsCount = 29,
			result = parseInt(progress) * 100 / parseInt(platformsCount);

		if (result > 95) {
			$accounts.add($scanPopup).removeClass('loading');
		} else {
			$accountsLoggedProgress.text(Math.trunc(result) + '%');
		}

		platformsCount--;
	}

	/**
	 * @param {string} network
	 * @param {boolean} loggedIn
	 */
	function showResults(network, loggedIn) {
		var el = '<span class="account">' + network.name + '</span><br>';
		if (loggedIn) {
			$accountsLoggedAppList.append(el);
		}

		progress++;
		updateProgress(progress);
	}
	// /Scan logged in applications

	// Animate loader
	function animateLoader() {
		var walkway = new Walkway({
			selector: '#fingerprint-animation',
			duration: 5000,
			// length of the animation
			// https://github.com/AndrewRayCode/easing-utils/blob/master/src/easing.js
			easing: 'easeInOutCubic'
		});

		document.querySelector('[data-animation="fingerprint"]').style.opacity = '1';
		walkway.draw();
	}

	// Toggle scan popup
	function toggleLoader(data) {
		if (data === 'showLoader') {
			$resultsContent.addClass('hide');
			$loadingContent.removeClass('hide');
		} else {
			$resultsContent.removeClass('hide');
			$loadingContent.addClass('hide');
		}
	}
	$scanPopupOpen.on('click', function(event) {
		event.preventDefault();
		window.location.hash = 'freescan';
		count = 0;
		progress = 0;
		$accountsLoggedAppList.html('');
		$scanPopup.removeClass('hide');
		$loadingContent.addClass('loading');
		$accounts.add($scanPopup).addClass('loading');
		animateLoader();

		if (createjsLoaded) {
			initScanPopupLoaderAnimation();
		}

		loaderTimeout = setTimeout(toggleLoader, 5500);

		loggedAccounts(showResults);

		window.scanPopupTimeout = setTimeout(function() {
			$scanPopup.removeClass('loading');
		}, 3000);
	});

	$scanPopupClose.on('click', function() {
		$scanPopup.addClass('hide');
		window.location.hash = '!';
		clearTimeout(window.scanPopupTimeout);
		clearTimeout(loaderTimeout);
		toggleLoader('showLoader');
		$loadingContent.removeClass('loading');
	});

	$document.keyup(function(event) {
		if (event.keyCode === 27) {
			$scanPopup.addClass('hide');
			clearTimeout(window.scanPopupTimeout);
			clearTimeout(loaderTimeout);
			window.location.hash = '!';
			toggleLoader('showLoader');
			$loadingContent.removeClass('loading');
		}
	});

	$document.on('click', function(event) {
		if (!$scanPopup.hasClass('hide') && $(event.target).is($scanPopup)) {
			$scanPopup.addClass('hide');
			window.location.hash = '!';
			clearTimeout(window.scanPopupTimeout);
			clearTimeout(loaderTimeout);
			toggleLoader('showLoader');
			$loadingContent.removeClass('loading');
		}
	});
	// /Toggle scan popup

	// Tabs switcher
	$tab.on('mouseenter', function() {
		var $self = $(this),
			$selfTabsBlock = $self.parent().parent().parent().find('.js-tabs-block'),
			$selfSections = $selfTabsBlock.find('.js-tab-section'),
			$selfTabs = $self.parent().find('.js-tab'),
			tabIndex = $selfTabs.index($self);

		$selfTabs.removeClass('active');
		$selfSections.removeClass('active');
		$selfTabs.eq(tabIndex).addClass('active');
		$selfSections.eq(tabIndex).addClass('active');
	});
	// /Tabs switcher

})();

/* Custom createJS animation script */
$(window).on('createjs', function() {
	window.createjsLoaded = true;
	var AdobeAn = typeof AdobeAn !== 'undefined' ? AdobeAn : {};
	window.an = typeof AdobeAn !== 'undefined' ? AdobeAn : {};
	window.cjs = createjs||{};
	var p; // shortcut to reference prototypes
	var lib={};var ss={};var img={};
	lib.ssMetadata = [];


	// symbols:



	(lib.Tween1 = function(mode,startPosition,loop) {
		this.initialize(mode,startPosition,loop,{});

		// Layer 1
		this.shape = new cjs.Shape();
		this.shape.graphics.f("#0CB754").s().p("AliSDMAAAgkFILFAAMAAAAkFg");

		this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	}).prototype = p = new cjs.MovieClip();
	p.nominalBounds = new cjs.Rectangle(-35.5,-115.5,71,231);


	(lib.fingerprint = function(mode,startPosition,loop) {
		this.initialize(mode,startPosition,loop,{});

		// Layer 3 (mask)
		var mask = new cjs.Shape();
		mask._off = true;
		mask.graphics.p("Ai9KPQgHgEgCgIQgCgIAEgHQBaidBFgFQBIgNBPCQQAEAIgCAIQgCAHgIAEQgHAEgIgCQgIgCgEgIQg+hxgxADQg1AJhNCFQgEAHgIACIgFABQgFAAgFgDgAlNJfQgHgCgFgHQgEgHACgIQACgIAHgFQAngYAjgjIABAAQBchcAQh8QABgIAHgFQAHgFAIABQAIABAFAHQAFAGgBAIQgSCJhmBmIAAAAQgnAngrAaQgFADgGAAIgFAAgADtJQQgIAAgGgGQg9hGg/hMQixjWhViEIAAAAQgcgtAAgwQAAg+AsgrIAAAAQAtgsA9AAQA+AAArAsQAIAHAKAOQCFCvCbCeQA3A3A7A3QAGAGABAIQAAAIgGAGQgFAGgJABQgIAAgGgFQg8g4g3g4QidigiHixIgOgRQgggggtAAQgtAAghAgIAAAAQggAgAAAtQAAAlAWAjIAAAAQBUCCCuDUQA/BLA9BFQAGAGgBAJQAAAIgHAFQgFAFgIAAIgBAAgAF2HzQgIAAgGgGQjkjmjGj/QgFgHABgHQABgIAGgFQAHgFAIABQAIABAFAHQDFD8DiDkQAGAGAAAIQAAAJgGAGQgGAFgIAAIAAAAgAmvHoQgHgDgDgIQgDgIADgHQAEgIAHgDQAwgSAmgnIAAAAQBKhJAAhnQAAgvgWg6QgYhEAAgsQAAhxBQhRIABAAQBRhQBxAAQBxAABQBQQAQAQAHAIIgBAAQB9CQCYCPQA1AyA6A1QAHAFAAAJQABAIgGAGQgGAGgIABQgIAAgGgFQg7g2g1gyQiaiSh+iQIAAgBIgUgUQhFhFhgAAQhhAAhFBEIAAABQhFBFAABgQAAAnAWA8QAYBBAAA1QAAB3hWBVIAAABQgsAtg3AVIgHABQgEAAgFgCgAnuFvQgHgEgDgHQgDgIADgIQADgHAIgDQAZgKAVgVIAAAAQAogoAAg3QgBgTgNgpIAAAAQgZhPAAhAQAAimB2h4IABAAQB3h2CnAAQBzAABbA8QA/ApBZBsIAAAAQAoAvA3A5IAAAAQAnAoA+AuQAHAEABAIQACAIgFAHQgFAHgIABQgIABgHgFQhCgvgpgqIAAAAQg4g6gpgxIAAAAQhUhlg7gnQhRg2hnAAQiXAAhrBqIAAABQhrBrAACWQAAA7AXBIIAAAAQAQAxAAAXQAABIg0AzIAAAAQgbAbghANIgHABQgEAAgEgBgAoCDmQgIgDgEgIQgehCgKhLQgBgIAFgHQAFgGAIgBQAJgCAGAGQAHAFABAIQAJBFAcA9QADAHgDAIQgCAIgIADQgEACgEAAIgHgBgAokgdQgJAAgGgGQgFgGAAgIIAAgKIAAAAQATi0CFiGIAAAAQCcibDbAAQC6AACNBxQAGAFABAIQABAIgFAHQgFAGgJABQgIABgGgFQiChoisAAQjKAAiRCPIAAAAQh6B8gSCmIAAABIAAAFQAAAIgGAGQgGAGgIAAIAAAAgAHdinQgJAAgGgGIiHiJQgGgGAAgIQAAgIAGgGQAGgGAIAAQAJAAAFAGICICJQAGAGAAAIQAAAJgGAGQgGAFgIAAIAAAAgAGBm9Qiyisj3AAQj3AAiyCpQgGAFgIAAQgJAAgFgGQgGgGAAgIQAAgJAGgFQC+i0EHAAQEHAAC+C3QAGAGAAAIQAAAIgFAGQgGAGgIAAIgBAAQgIAAgGgFg");
		mask.setTransform(54.9,63.8);

		// Layer 5
		this.shape = new cjs.Shape();
		this.shape.graphics.f().s("rgba(137,157,213,0.329)").ss(8,1,1,3,true).p("AAAABQAAgBABAA");
		this.shape.setTransform(7.1,17.3);

		this.shape_1 = new cjs.Shape();
		this.shape_1.graphics.f().s("rgba(137,157,213,0.659)").ss(8,1,1,3,true).p("AgCADQACgDADgC");
		this.shape_1.setTransform(7.2,17.1);

		this.shape_2 = new cjs.Shape();
		this.shape_2.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AgEAFQAEgFAFgE");
		this.shape_2.setTransform(7.5,16.9);

		this.shape_3 = new cjs.Shape();
		this.shape_3.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AgIAJQAIgJAJgH");
		this.shape_3.setTransform(7.9,16.6);

		this.shape_4 = new cjs.Shape();
		this.shape_4.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AgOAOQAOgOAPgN");
		this.shape_4.setTransform(8.5,16);

		this.shape_5 = new cjs.Shape();
		this.shape_5.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AgXAVQAXgVAYgU");
		this.shape_5.setTransform(9.3,15.3);

		this.shape_6 = new cjs.Shape();
		this.shape_6.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AgjAeQAjggAkgb");
		this.shape_6.setTransform(10.5,14.4);

		this.shape_7 = new cjs.Shape();
		this.shape_7.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AgyAoQAwgtA1gi");
		this.shape_7.setTransform(12.1,13.4);

		this.shape_8 = new cjs.Shape();
		this.shape_8.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AhHA0QBDg/BMgo");
		this.shape_8.setTransform(14.2,12.2);

		this.shape_9 = new cjs.Shape();
		this.shape_9.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AhfA/QBYhSBngr");
		this.shape_9.setTransform(16.5,11.1);

		this.shape_10 = new cjs.Shape();
		this.shape_10.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("Ah1BHQBqhjCBgq");
		this.shape_10.setTransform(18.7,10.3);

		this.shape_11 = new cjs.Shape();
		this.shape_11.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AiQBPQCAh4Chgl");
		this.shape_11.setTransform(21.5,9.5);

		this.shape_12 = new cjs.Shape();
		this.shape_12.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("Ai7BWQChiYDWgT");
		this.shape_12.setTransform(25.8,8.8);

		this.shape_13 = new cjs.Shape();
		this.shape_13.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AjnBXQC4itD+AAQAMAAANAB");
		this.shape_13.setTransform(30.1,8.7);

		this.shape_14 = new cjs.Shape();
		this.shape_14.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AkWBXQC4itD+AAQA9AAA6AK");
		this.shape_14.setTransform(34.8,8.7);

		this.shape_15 = new cjs.Shape();
		this.shape_15.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("Ak9BXQC3itD+AAQBpAABdAe");
		this.shape_15.setTransform(38.8,8.7);

		this.shape_16 = new cjs.Shape();
		this.shape_16.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AldBXQC4itD+AAQCNAAB4A2");
		this.shape_16.setTransform(41.9,8.7);

		this.shape_17 = new cjs.Shape();
		this.shape_17.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("Al5BXQC3itD+AAQCwAACOBT");
		this.shape_17.setTransform(44.8,8.7);

		this.shape_18 = new cjs.Shape();
		this.shape_18.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AmPBXQC4itD+AAQDLAACeBu");
		this.shape_18.setTransform(46.9,8.7);

		this.shape_19 = new cjs.Shape();
		this.shape_19.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AmeBXQC3itD+AAQDgAACoCG");
		this.shape_19.setTransform(48.5,8.7);

		this.shape_20 = new cjs.Shape();
		this.shape_20.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AmsBXQC3itD+AAQDyAACyCd");
		this.shape_20.setTransform(49.9,8.7);

		this.shape_21 = new cjs.Shape();
		this.shape_21.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("Am0BXQC3itD+AAQD+AAC2Cs");
		this.shape_21.setTransform(50.7,8.7);

		this.shape_22 = new cjs.Shape();
		this.shape_22.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("Am2BVQC3itD/AAQEAAAC3Cx");
		this.shape_22.setTransform(50.9,8.9);

		var maskedShapeInstanceList = [this.shape,this.shape_1,this.shape_2,this.shape_3,this.shape_4,this.shape_5,this.shape_6,this.shape_7,this.shape_8,this.shape_9,this.shape_10,this.shape_11,this.shape_12,this.shape_13,this.shape_14,this.shape_15,this.shape_16,this.shape_17,this.shape_18,this.shape_19,this.shape_20,this.shape_21,this.shape_22];

		for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
			maskedShapeInstanceList[shapedInstanceItr].mask = mask;
		}

		this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape}]},6).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.shape_2}]},1).to({state:[{t:this.shape_3}]},1).to({state:[{t:this.shape_4}]},1).to({state:[{t:this.shape_5}]},1).to({state:[{t:this.shape_6}]},1).to({state:[{t:this.shape_7}]},1).to({state:[{t:this.shape_8}]},1).to({state:[{t:this.shape_9}]},1).to({state:[{t:this.shape_10}]},1).to({state:[{t:this.shape_11}]},1).to({state:[{t:this.shape_12}]},1).to({state:[{t:this.shape_13}]},1).to({state:[{t:this.shape_14}]},1).to({state:[{t:this.shape_15}]},1).to({state:[{t:this.shape_16}]},1).to({state:[{t:this.shape_17}]},1).to({state:[{t:this.shape_18}]},1).to({state:[{t:this.shape_19}]},1).to({state:[{t:this.shape_20}]},1).to({state:[{t:this.shape_21}]},1).to({state:[{t:this.shape_22}]},1).wait(97));

		// Layer 6
		this.shape_23 = new cjs.Shape();
		this.shape_23.graphics.f().s("rgba(137,157,213,0.329)").ss(8,1,1,3,true).p("AAAAAIACAB");
		this.shape_23.setTransform(102.5,44.9);

		this.shape_24 = new cjs.Shape();
		this.shape_24.graphics.f().s("rgba(137,157,213,0.659)").ss(8,1,1,3,true).p("AgDgDIAHAH");
		this.shape_24.setTransform(102.2,44.6);

		this.shape_25 = new cjs.Shape();
		this.shape_25.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AgGgGIANAN");
		this.shape_25.setTransform(101.9,44.3);

		this.shape_26 = new cjs.Shape();
		this.shape_26.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AgLgLIAXAX");
		this.shape_26.setTransform(101.4,43.8);

		this.shape_27 = new cjs.Shape();
		this.shape_27.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AgSgSIAlAl");
		this.shape_27.setTransform(100.7,43.1);

		this.shape_28 = new cjs.Shape();
		this.shape_28.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AgbgbIA3A3");
		this.shape_28.setTransform(99.8,42.2);

		this.shape_29 = new cjs.Shape();
		this.shape_29.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AgngoIBPBQ");
		this.shape_29.setTransform(98.6,41);

		this.shape_30 = new cjs.Shape();
		this.shape_30.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("Agzg0IBnBp");
		this.shape_30.setTransform(97.4,39.7);

		this.shape_31 = new cjs.Shape();
		this.shape_31.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("Ag8g8IB5B5");
		this.shape_31.setTransform(96.5,38.9);

		this.shape_32 = new cjs.Shape();
		this.shape_32.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AhAhBICBCD");
		this.shape_32.setTransform(96.1,38.4);

		this.shape_33 = new cjs.Shape();
		this.shape_33.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AhDhDICHCI");
		this.shape_33.setTransform(95.8,38.2);

		this.shape_34 = new cjs.Shape();
		this.shape_34.graphics.f().s("rgba(137,157,213,0.329)").ss(8,1,1,3,true).p("AgBgBQABABACAC");
		this.shape_34.setTransform(82,23.5);

		this.shape_35 = new cjs.Shape();
		this.shape_35.graphics.f().s("rgba(137,157,213,0.659)").ss(8,1,1,3,true).p("AgFgEQAFAEAGAF");
		this.shape_35.setTransform(81.7,23.2);

		this.shape_36 = new cjs.Shape();
		this.shape_36.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AgWgVICHCIAhwhyQALAIALAJ");
		this.shape_36.setTransform(91.3,33.5);

		this.shape_37 = new cjs.Shape();
		this.shape_37.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AgOgQICGCIAh3h3QATANASAO");
		this.shape_37.setTransform(90.6,33);

		this.shape_38 = new cjs.Shape();
		this.shape_38.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AgCgIICHCIAiEh/QAgATAeAY");
		this.shape_38.setTransform(89.3,32.2);

		this.shape_39 = new cjs.Shape();
		this.shape_39.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AAPAAICHCJAiViIQAzAYAuAl");
		this.shape_39.setTransform(87.6,31.3);

		this.shape_40 = new cjs.Shape();
		this.shape_40.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AAmAJICHCKAisiSQBNAcBCA0");
		this.shape_40.setTransform(85.3,30.4);

		this.shape_41 = new cjs.Shape();
		this.shape_41.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AA/ARICHCJAjGiZQBrAZBXBG");
		this.shape_41.setTransform(82.8,29.6);

		this.shape_42 = new cjs.Shape();
		this.shape_42.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("ABdAWICHCJAjjieQCNAQBvBZ");
		this.shape_42.setTransform(79.8,29.1);

		this.shape_43 = new cjs.Shape();
		this.shape_43.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AB8AYICHCJAkCigQC0AACGBt");
		this.shape_43.setTransform(76.7,28.9);

		this.shape_44 = new cjs.Shape();
		this.shape_44.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("ACfAYICHCJAklicQAigEAkAAQC0AACGBt");
		this.shape_44.setTransform(73.2,28.9);

		this.shape_45 = new cjs.Shape();
		this.shape_45.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("ADIAYICICJAlPiKQBIgWBRAAQC0AACGBt");
		this.shape_45.setTransform(69.1,28.9);

		this.shape_46 = new cjs.Shape();
		this.shape_46.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("ADuAYICICJAl1hrQBog1B9AAQCzAACHBt");
		this.shape_46.setTransform(65.2,28.9);

		this.shape_47 = new cjs.Shape();
		this.shape_47.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AEWAYICHCJAmcg5QCFhnCvAAQCzAACHBt");
		this.shape_47.setTransform(61.3,28.9);

		this.shape_48 = new cjs.Shape();
		this.shape_48.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AE2AYICHCJAm8AAQAFgFAGgGQCWiVDTAAQCzAACHBt");
		this.shape_48.setTransform(58.1,28.9);

		this.shape_49 = new cjs.Shape();
		this.shape_49.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AFOAYICHCJAnUA6QAagkAhghQCWiVDTAAQCzAACHBt");
		this.shape_49.setTransform(55.7,28.9);

		this.shape_50 = new cjs.Shape();
		this.shape_50.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AFcAYICICJAnjBoQAjg+A1g1QCWiVDTAAQCzAACHBt");
		this.shape_50.setTransform(54.2,28.9);

		this.shape_51 = new cjs.Shape();
		this.shape_51.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AFpAYICHCJAnvCdQAlhcBMhMQCWiVDTAAQCzAACHBt");
		this.shape_51.setTransform(53,28.9);

		this.shape_52 = new cjs.Shape();
		this.shape_52.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AFxABICICJAn4C4QAih6BghgQCWiVDTAAQCzAACHBt");
		this.shape_52.setTransform(52.1,31.2);

		this.shape_53 = new cjs.Shape();
		this.shape_53.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AF2gRICHCIAn8DKQAciQBvhuQCWiVDTAAQCzAACHBs");
		this.shape_53.setTransform(51.7,33.1);

		this.shape_54 = new cjs.Shape();
		this.shape_54.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AF4gfICICIAn/DZQAXiiB5h6QCWiVDTAAQCzAACHBt");
		this.shape_54.setTransform(51.4,34.5);

		this.shape_55 = new cjs.Shape();
		this.shape_55.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AF6gsICHCIAoADmQAAgEAAgEQATitB/iAQCWiVDUAAQCzAACHBs");
		this.shape_55.setTransform(51.3,35.8);

		this.shape_56 = new cjs.Shape();
		this.shape_56.graphics.f().s("rgba(137,157,213,0.329)").ss(8,1,1,3,true).p("AABAEQgBgEAAgD");
		this.shape_56.setTransform(0.3,71.7);

		this.shape_57 = new cjs.Shape();
		this.shape_57.graphics.f().s("rgba(137,157,213,0.659)").ss(8,1,1,3,true).p("AABAIQgBgIAAgI");
		this.shape_57.setTransform(0.4,72.2);

		this.shape_58 = new cjs.Shape();
		this.shape_58.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AF6h5ICHCIAn5EzQgDgPgCgOAoACYQAAgEAAgDQATitB/iBQCWiVDUAAQCzAACHBt");
		this.shape_58.setTransform(51.3,43.5);

		this.shape_59 = new cjs.Shape();
		this.shape_59.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AF6iHICHCIAnzFAQgHgbgEgdAoACLQAAgEAAgEQATisB/iBQCWiVDUAAQCzAACHBs");
		this.shape_59.setTransform(51.3,44.9);

		this.shape_60 = new cjs.Shape();
		this.shape_60.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AF6iSICHCJAnsFMQgMgmgGgpAoAB/QAAgEAAgDQATitB/iBQCWiVDUAAQCzAACHBt");
		this.shape_60.setTransform(51.3,46);

		this.shape_61 = new cjs.Shape();
		this.shape_61.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AF6ijICHCJAnhFdQgVg2gIg7AoABvQAAgEAAgEQATisB/iBQCWiVDUAAQCzAACHBs");
		this.shape_61.setTransform(51.3,47.7);

		this.shape_62 = new cjs.Shape();
		this.shape_62.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AF6irICHCJAnaFlQgag9gKhEAoABmQAAgEAAgDQATitB/iBQCWiVDUAAQCzAACHBt");
		this.shape_62.setTransform(51.3,48.6);

		this.shape_63 = new cjs.Shape();
		this.shape_63.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AF6iuICHCJAnXFoQgdg/gKhIAoABjQAAgEAAgDQATitB/iBQCWiVDUAAQCzAACHBt");
		this.shape_63.setTransform(51.3,48.9);

		var maskedShapeInstanceList = [this.shape_23,this.shape_24,this.shape_25,this.shape_26,this.shape_27,this.shape_28,this.shape_29,this.shape_30,this.shape_31,this.shape_32,this.shape_33,this.shape_34,this.shape_35,this.shape_36,this.shape_37,this.shape_38,this.shape_39,this.shape_40,this.shape_41,this.shape_42,this.shape_43,this.shape_44,this.shape_45,this.shape_46,this.shape_47,this.shape_48,this.shape_49,this.shape_50,this.shape_51,this.shape_52,this.shape_53,this.shape_54,this.shape_55,this.shape_56,this.shape_57,this.shape_58,this.shape_59,this.shape_60,this.shape_61,this.shape_62,this.shape_63];

		for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
			maskedShapeInstanceList[shapedInstanceItr].mask = mask;
		}

		this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape_23}]},20).to({state:[{t:this.shape_24}]},1).to({state:[{t:this.shape_25}]},1).to({state:[{t:this.shape_26}]},1).to({state:[{t:this.shape_27}]},1).to({state:[{t:this.shape_28}]},1).to({state:[{t:this.shape_29}]},1).to({state:[{t:this.shape_30}]},1).to({state:[{t:this.shape_31}]},1).to({state:[{t:this.shape_32}]},1).to({state:[{t:this.shape_33}]},1).to({state:[{t:this.shape_34},{t:this.shape_33}]},1).to({state:[{t:this.shape_35},{t:this.shape_33}]},1).to({state:[{t:this.shape_36}]},1).to({state:[{t:this.shape_37}]},1).to({state:[{t:this.shape_38}]},1).to({state:[{t:this.shape_39}]},1).to({state:[{t:this.shape_40}]},1).to({state:[{t:this.shape_41}]},1).to({state:[{t:this.shape_42}]},1).to({state:[{t:this.shape_43}]},1).to({state:[{t:this.shape_44}]},1).to({state:[{t:this.shape_45}]},1).to({state:[{t:this.shape_46}]},1).to({state:[{t:this.shape_47}]},1).to({state:[{t:this.shape_48}]},1).to({state:[{t:this.shape_49}]},1).to({state:[{t:this.shape_50}]},1).to({state:[{t:this.shape_51}]},1).to({state:[{t:this.shape_52}]},1).to({state:[{t:this.shape_53}]},1).to({state:[{t:this.shape_54}]},1).to({state:[{t:this.shape_55}]},1).to({state:[{t:this.shape_55},{t:this.shape_56}]},1).to({state:[{t:this.shape_55},{t:this.shape_57}]},1).to({state:[{t:this.shape_58}]},1).to({state:[{t:this.shape_59}]},1).to({state:[{t:this.shape_60}]},1).to({state:[{t:this.shape_61}]},1).to({state:[{t:this.shape_62}]},1).to({state:[{t:this.shape_63}]},1).wait(65));

		// Layer 7
		this.shape_64 = new cjs.Shape();
		this.shape_64.graphics.f().s("rgba(137,157,213,0.329)").ss(8,1,1,3,true).p("AgBABQABgBACAA");
		this.shape_64.setTransform(6.5,98.5);

		this.shape_65 = new cjs.Shape();
		this.shape_65.graphics.f().s("rgba(137,157,213,0.659)").ss(8,1,1,3,true).p("AgFADQAFgDAGgC");
		this.shape_65.setTransform(6.9,98.3);

		this.shape_66 = new cjs.Shape();
		this.shape_66.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AgJAFQAJgEAKgF");
		this.shape_66.setTransform(7.3,98.1);

		this.shape_67 = new cjs.Shape();
		this.shape_67.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AgOAIQAPgGAOgJ");
		this.shape_67.setTransform(7.8,97.8);

		this.shape_68 = new cjs.Shape();
		this.shape_68.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AgVANQAXgJAUgQ");
		this.shape_68.setTransform(8.5,97.3);

		this.shape_69 = new cjs.Shape();
		this.shape_69.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AgeAXQAdgMAXgXQAFgFAEgF");
		this.shape_69.setTransform(9.4,96.4);

		this.shape_70 = new cjs.Shape();
		this.shape_70.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AgmAiQAdgMAXgXQAPgPAKgR");
		this.shape_70.setTransform(10.2,95.2);

		this.shape_71 = new cjs.Shape();
		this.shape_71.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AguA2QAdgLAXgYQAggfAJgp");
		this.shape_71.setTransform(11,93.2);

		this.shape_72 = new cjs.Shape();
		this.shape_72.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AgwBPQAdgMAXgYQAtgsAAg/QAAgGgBgI");
		this.shape_72.setTransform(11.2,90.7);

		this.shape_73 = new cjs.Shape();
		this.shape_73.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AgwBpQAdgLAXgYQAtgtAAg/QAAgVgOgt");
		this.shape_73.setTransform(11.2,88.1);

		this.shape_74 = new cjs.Shape();
		this.shape_74.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AgwCRQAdgLAXgYQAtgtAAhAQAAgUgOgtQgOgqgGgm");
		this.shape_74.setTransform(11.2,84.1);

		this.shape_75 = new cjs.Shape();
		this.shape_75.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AgwC/QAdgMAXgYQAtgtAAg/QAAgWgOgsQgYhLAAg+QAAgRABgR");
		this.shape_75.setTransform(11.2,79.5);

		this.shape_76 = new cjs.Shape();
		this.shape_76.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AgwDrQAdgLAXgYQAtgtAAhAQAAgVgOgtQgYhLAAg9QAAhCATg5");
		this.shape_76.setTransform(11.2,75.1);

		this.shape_77 = new cjs.Shape();
		this.shape_77.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("Ag5ESQAdgLAYgYQAtgtAAhAQAAgVgPgtQgYhLAAg9QAAhwA4ha");
		this.shape_77.setTransform(12,71.2);

		this.shape_78 = new cjs.Shape();
		this.shape_78.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AhUE0QAegLAYgYQAsgtAAhAQAAgVgOgtQgXhMAAg8QAAidBshw");
		this.shape_78.setTransform(14.7,67.8);

		this.shape_79 = new cjs.Shape();
		this.shape_79.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AhyFOQAdgLAYgYQAtgtAAhAQAAgVgOgtQgYhMAAg8QAAifBvhyQAcgbAegV");
		this.shape_79.setTransform(17.8,65.2);

		this.shape_80 = new cjs.Shape();
		this.shape_80.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AiRFfQAdgMAYgYQAugtAAg/QAAgWgPgtQgYhLAAg+QAAieBwhxQA2g2BBgc");
		this.shape_80.setTransform(20.8,63.5);

		this.shape_81 = new cjs.Shape();
		this.shape_81.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("Ai4FrQAdgMAYgYQAugtAAg/QAAgWgPgtQgYhLAAg+QAAieBxhxQBUhVBwgV");
		this.shape_81.setTransform(24.7,62.3);

		this.shape_82 = new cjs.Shape();
		this.shape_82.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AjmFuQAdgLAYgYQAtgtAAhAQAAgVgOgtQgYhMAAg9QAAieBwhyQBwhwCgAAQAJAAAIAA");
		this.shape_82.setTransform(29.4,62);

		this.shape_83 = new cjs.Shape();
		this.shape_83.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AkPFuQAdgLAYgYQAugtAAhAQAAgVgPgtQgYhMAAg9QAAieBxhyQBwhwCfAAQA0AAAvAN");
		this.shape_83.setTransform(33.4,62);

		this.shape_84 = new cjs.Shape();
		this.shape_84.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("Ak1FuQAdgLAYgYQAugtAAhAQAAgVgPgtQgYhMAAg9QAAieBxhyQBxhwCeAAQBhAABOAs");
		this.shape_84.setTransform(37.2,62);

		this.shape_85 = new cjs.Shape();
		this.shape_85.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AlVFuQAdgLAYgYQAugtAAhAQAAgVgPgtQgYhMAAg9QAAieBxhyQBxhwCeAAQBuAABWA5QAUANAXAU");
		this.shape_85.setTransform(40.4,62);

		this.shape_86 = new cjs.Shape();
		this.shape_86.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AlwFuQAdgLAYgYQAugtAAhAQAAgVgPgtQgYhMAAg9QAAieBxhyQBxhwCeAAQBuAABWA5QAqAbA3A6");
		this.shape_86.setTransform(43.1,62);

		this.shape_87 = new cjs.Shape();
		this.shape_87.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AmJFuQAdgLAYgYQAtgtAAhAQAAgVgOgtQgYhMAAg9QAAieBwhyQBxhwCfAAQBtAABWA5QA+AoBWBo");
		this.shape_87.setTransform(45.7,62);

		this.shape_88 = new cjs.Shape();
		this.shape_88.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AmgFuQAdgLAZgYQAtgtAAhAQAAgVgPgtQgYhMAAg9QAAieBxhyQBxhwCfAAQBtAABWA5QA+AoBWBoQAUAYAZAb");
		this.shape_88.setTransform(47.9,62);

		this.shape_89 = new cjs.Shape();
		this.shape_89.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AmyFuQAdgLAYgYQAtgtAAhAQAAgVgOgtQgYhMAAg9QAAieBwhyQBxhwCfAAQBtAABWA5QA+AoBWBoQAjAqAvAy");
		this.shape_89.setTransform(49.8,62);

		this.shape_90 = new cjs.Shape();
		this.shape_90.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AnEFuQAdgLAYgYQAugtAAhAQAAgVgPgtQgYhMAAg9QAAieBxhyQBxhwCfAAQBtAABWA5QA+AoBWBoQAoAwA4A6QAKAKALAK");
		this.shape_90.setTransform(51.5,62);

		this.shape_91 = new cjs.Shape();
		this.shape_91.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AnUFuQAdgLAYgYQAugtAAhAQAAgVgPgtQgYhMAAg9QAAieBxhyQBxhwCfAAQBtAABWA5QA+AoBWBoQAoAwA4A6QAWAXAfAZ");
		this.shape_91.setTransform(53.1,62);

		this.shape_92 = new cjs.Shape();
		this.shape_92.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AnfFuQAdgLAYgYQAugtAAhAQAAgVgPgtQgYhMAAg9QAAieBxhyQBxhwCfAAQBtAABWA5QA9AoBXBoQAoAwA4A6QAeAgAtAh");
		this.shape_92.setTransform(54.2,62);

		this.shape_93 = new cjs.Shape();
		this.shape_93.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AnqFuQAdgLAYgYQAugtAAhAQAAgVgPgtQgYhMAAg9QAAieBxhyQBxhwCgAAQBsAABWA5QA+AoBWBoQAoAwA4A6QAmAnA7Ar");
		this.shape_93.setTransform(55.3,62);

		this.shape_94 = new cjs.Shape();
		this.shape_94.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AntFuQAdgLAYgYQAtgtAAhAQAAgVgOgtQgYhMAAg9QAAieBwhyQBxhwCgAAQBsAABWA5QA+AoBWBoQAoAwA4A6QAoApBAAu");
		this.shape_94.setTransform(55.7,62);

		var maskedShapeInstanceList = [this.shape_64,this.shape_65,this.shape_66,this.shape_67,this.shape_68,this.shape_69,this.shape_70,this.shape_71,this.shape_72,this.shape_73,this.shape_74,this.shape_75,this.shape_76,this.shape_77,this.shape_78,this.shape_79,this.shape_80,this.shape_81,this.shape_82,this.shape_83,this.shape_84,this.shape_85,this.shape_86,this.shape_87,this.shape_88,this.shape_89,this.shape_90,this.shape_91,this.shape_92,this.shape_93,this.shape_94];

		for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
			maskedShapeInstanceList[shapedInstanceItr].mask = mask;
		}

		this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape_64}]},39).to({state:[{t:this.shape_65}]},1).to({state:[{t:this.shape_66}]},1).to({state:[{t:this.shape_67}]},1).to({state:[{t:this.shape_68}]},1).to({state:[{t:this.shape_69}]},1).to({state:[{t:this.shape_70}]},1).to({state:[{t:this.shape_71}]},1).to({state:[{t:this.shape_72}]},1).to({state:[{t:this.shape_73}]},1).to({state:[{t:this.shape_74}]},1).to({state:[{t:this.shape_75}]},1).to({state:[{t:this.shape_76}]},1).to({state:[{t:this.shape_77}]},1).to({state:[{t:this.shape_78}]},1).to({state:[{t:this.shape_79}]},1).to({state:[{t:this.shape_80}]},1).to({state:[{t:this.shape_81}]},1).to({state:[{t:this.shape_82}]},1).to({state:[{t:this.shape_83}]},1).to({state:[{t:this.shape_84}]},1).to({state:[{t:this.shape_85}]},1).to({state:[{t:this.shape_86}]},1).to({state:[{t:this.shape_87}]},1).to({state:[{t:this.shape_88}]},1).to({state:[{t:this.shape_89}]},1).to({state:[{t:this.shape_90}]},1).to({state:[{t:this.shape_91}]},1).to({state:[{t:this.shape_92}]},1).to({state:[{t:this.shape_93}]},1).to({state:[{t:this.shape_94}]},1).wait(56));

		// Layer 8
		this.shape_95 = new cjs.Shape();
		this.shape_95.graphics.f().s("rgba(137,157,213,0.329)").ss(8,1,1,3,true).p("AgBgBQABABACAC");
		this.shape_95.setTransform(109.6,87.2);

		this.shape_96 = new cjs.Shape();
		this.shape_96.graphics.f().s("rgba(137,157,213,0.659)").ss(8,1,1,3,true).p("AgEgDQAEADAEAE");
		this.shape_96.setTransform(109.4,87);

		this.shape_97 = new cjs.Shape();
		this.shape_97.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AgJgIQAJAIAKAJ");
		this.shape_97.setTransform(108.9,86.5);

		this.shape_98 = new cjs.Shape();
		this.shape_98.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AgQgOQAQAOARAP");
		this.shape_98.setTransform(108.2,85.8);

		this.shape_99 = new cjs.Shape();
		this.shape_99.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AgZgWQAZAWAaAX");
		this.shape_99.setTransform(107.3,85);

		this.shape_100 = new cjs.Shape();
		this.shape_100.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AgngjQAmAjApAl");
		this.shape_100.setTransform(105.9,83.7);

		this.shape_101 = new cjs.Shape();
		this.shape_101.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("Ag6g2QADAEAEADQAzAxA7A1");
		this.shape_101.setTransform(103.9,81.9);

		this.shape_102 = new cjs.Shape();
		this.shape_102.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AhQhLQAZAYAaAZQA0AxA7A1");
		this.shape_102.setTransform(101.7,79.7);

		this.shape_103 = new cjs.Shape();
		this.shape_103.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AhqhkQAyAxA0AyQA0AxA7A1");
		this.shape_103.setTransform(99.2,77.2);

		this.shape_104 = new cjs.Shape();
		this.shape_104.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AiAh7QBGBIBLBIQA1AyA7A1");
		this.shape_104.setTransform(97,75);

		this.shape_105 = new cjs.Shape();
		this.shape_105.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AiUiQQBXBdBjBdQA0AyA7A1");
		this.shape_105.setTransform(95,72.8);

		this.shape_106 = new cjs.Shape();
		this.shape_106.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AipioQBpB1B7B1QA1AyA6A1");
		this.shape_106.setTransform(92.8,70.5);

		this.shape_107 = new cjs.Shape();
		this.shape_107.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AjHjJQAGAHAEAEQB9CQCYCRQA1AyA7A1");
		this.shape_107.setTransform(89.9,67.2);

		this.shape_108 = new cjs.Shape();
		this.shape_108.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("Aj4jsQAwATAnAnQAPAPAGAIQB9CQCZCRQA0AyA7A1");
		this.shape_108.setTransform(84.9,63.7);

		this.shape_109 = new cjs.Shape();
		this.shape_109.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AkzjzQAMgBANAAQBpAABLBLQAPAPAGAHQB8CRCZCQQA1AyA7A1");
		this.shape_109.setTransform(79.1,62.9);

		this.shape_110 = new cjs.Shape();
		this.shape_110.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AlkjVQA3gfBEAAQBqAABKBLQAPAPAGAHQB8CRCaCQQA0AyA7A1");
		this.shape_110.setTransform(74.1,62.9);

		this.shape_111 = new cjs.Shape();
		this.shape_111.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AmLiTQAKgMAKgKQBLhLBqAAQBpAABLBLQAOAPAGAHQB9CRCZCQQA1AyA7A1");
		this.shape_111.setTransform(70.3,62.9);

		this.shape_112 = new cjs.Shape();
		this.shape_112.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AmghIQATg2ArgrQBLhLBpAAQBqAABJBLQAPAPAGAHQB9CRCaCQQA1AyA6A1");
		this.shape_112.setTransform(68.2,62.9);

		this.shape_113 = new cjs.Shape();
		this.shape_113.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AmmAXQAAgHAAgGQAAhoBLhLQBLhLBpAAQBpAABKBLQAPAPAGAHQB9CRCaCQQA0AyA7A1");
		this.shape_113.setTransform(67.6,62.9);

		this.shape_114 = new cjs.Shape();
		this.shape_114.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AmQByQgWg/AAgpQAAhoBLhLQBLhLBpAAQBpAABKBLQAPAPAGAHQB9CRCaCQQA0AyA7A1");
		this.shape_114.setTransform(67.6,62.9);

		this.shape_115 = new cjs.Shape();
		this.shape_115.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("Al5DPQgEgqgSgxQgXhAAAgqQAAhoBLhLQBLhLBpAAQBpAABKBLQAPAPAGAHQB9CRCaCQQA0AyA7A1");
		this.shape_115.setTransform(67.6,62.9);

		this.shape_116 = new cjs.Shape();
		this.shape_116.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AmDETQAKglAAgpQAAgygWg+QgXhAAAgoQAAhqBLhLQBLhKBpAAQBpAABKBKQAPAPAGAIQB9CQCaCRQA0AyA7A1");
		this.shape_116.setTransform(67.6,65.9);

		this.shape_117 = new cjs.Shape();
		this.shape_117.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AmnE5QAvhDAAhWQAAgygWg+QgXg/AAgpQAAhqBKhLQBLhKBqAAQBpAABKBKQAPAPAGAIQB9CQCaCRQA0AyA7A1");
		this.shape_117.setTransform(67.5,69.6);

		this.shape_118 = new cjs.Shape();
		this.shape_118.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("Am7FPQAEgEAEgEQBPhPAAhvQAAgygWg+QgXg/AAgpQAAhqBKhLQBLhKBqAAQBpAABKBKQAPAPAGAIQB9CQCaCRQA0AyA7A1");
		this.shape_118.setTransform(65.5,71.9);

		this.shape_119 = new cjs.Shape();
		this.shape_119.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AnLFcQAVgOATgUQBQhPAAhvQAAgygXg+QgXg/AAgpQAAhqBLhLQBLhKBpAAQBqAABJBKQAPAPAGAIQB9CQCaCRQA0AyA7A1");
		this.shape_119.setTransform(63.8,73.2);

		this.shape_120 = new cjs.Shape();
		this.shape_120.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AnZFkQAlgSAfggQBPhPAAhvQAAgygWg+QgXg/AAgpQAAhqBKhLQBLhKBqAAQBpAABKBKQAPAPAGAIQB9CQCZCRQA1AyA7A1");
		this.shape_120.setTransform(62.5,74);

		this.shape_121 = new cjs.Shape();
		this.shape_121.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AniFpQAvgUAngnQBQhPAAhwQAAgygXg9QgXg/AAgqQAAhpBLhLQBLhLBpAAQBpAABKBLQAPAPAGAHQB9CRCaCQQA0AyA7A1");
		this.shape_121.setTransform(61.6,74.4);

		this.shape_122 = new cjs.Shape();
		this.shape_122.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AnlFqQAzgTApgqQBQhPAAhwQAAgygXg8QgXhAAAgqQAAhqBLhLQBLhKBpAAQBpAABKBKQAPAPAGAIQB9CRCaCQQA0AyA7A1");
		this.shape_122.setTransform(61.2,74.6);

		var maskedShapeInstanceList = [this.shape_95,this.shape_96,this.shape_97,this.shape_98,this.shape_99,this.shape_100,this.shape_101,this.shape_102,this.shape_103,this.shape_104,this.shape_105,this.shape_106,this.shape_107,this.shape_108,this.shape_109,this.shape_110,this.shape_111,this.shape_112,this.shape_113,this.shape_114,this.shape_115,this.shape_116,this.shape_117,this.shape_118,this.shape_119,this.shape_120,this.shape_121,this.shape_122];

		for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
			maskedShapeInstanceList[shapedInstanceItr].mask = mask;
		}

		this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape_95}]},55).to({state:[{t:this.shape_96}]},1).to({state:[{t:this.shape_97}]},1).to({state:[{t:this.shape_98}]},1).to({state:[{t:this.shape_99}]},1).to({state:[{t:this.shape_100}]},1).to({state:[{t:this.shape_101}]},1).to({state:[{t:this.shape_102}]},1).to({state:[{t:this.shape_103}]},1).to({state:[{t:this.shape_104}]},1).to({state:[{t:this.shape_105}]},1).to({state:[{t:this.shape_106}]},1).to({state:[{t:this.shape_107}]},1).to({state:[{t:this.shape_108}]},1).to({state:[{t:this.shape_109}]},1).to({state:[{t:this.shape_110}]},1).to({state:[{t:this.shape_111}]},1).to({state:[{t:this.shape_112}]},1).to({state:[{t:this.shape_113}]},1).to({state:[{t:this.shape_114}]},1).to({state:[{t:this.shape_115}]},1).to({state:[{t:this.shape_116}]},1).to({state:[{t:this.shape_117}]},1).to({state:[{t:this.shape_118}]},1).to({state:[{t:this.shape_119}]},1).to({state:[{t:this.shape_120}]},1).to({state:[{t:this.shape_121}]},1).to({state:[{t:this.shape_122}]},1).wait(43));

		// Layer 9
		this.shape_123 = new cjs.Shape();
		this.shape_123.graphics.f().s("rgba(137,157,213,0.329)").ss(8,1,1,3,true).p("AACACQgCgCgBgB");
		this.shape_123.setTransform(78.6,120.8);

		this.shape_124 = new cjs.Shape();
		this.shape_124.graphics.f().s("rgba(137,157,213,0.659)").ss(8,1,1,3,true).p("AAFAFQgFgFgEgE");
		this.shape_124.setTransform(78.3,120.5);

		this.shape_125 = new cjs.Shape();
		this.shape_125.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AAIAJQgIgJgHgI");
		this.shape_125.setTransform(77.9,120.1);

		this.shape_126 = new cjs.Shape();
		this.shape_126.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AAOAQQgOgQgNgP");
		this.shape_126.setTransform(77.4,119.4);

		this.shape_127 = new cjs.Shape();
		this.shape_127.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AAWAZQgTgWgSgVQgDgDgDgD");
		this.shape_127.setTransform(76.6,118.5);

		this.shape_128 = new cjs.Shape();
		this.shape_128.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AAjApQgjgogigp");
		this.shape_128.setTransform(75.2,116.9);

		this.shape_129 = new cjs.Shape();
		this.shape_129.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AAyA6Qgxg4gyg7");
		this.shape_129.setTransform(73.8,115.2);

		this.shape_130 = new cjs.Shape();
		this.shape_130.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("ABGBTQg8hGg/hKQgIgLgIgK");
		this.shape_130.setTransform(71.7,112.7);

		this.shape_131 = new cjs.Shape();
		this.shape_131.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("ABfBwQg9hFg+hLQgjgpgfgm");
		this.shape_131.setTransform(69.3,109.8);

		this.shape_132 = new cjs.Shape();
		this.shape_132.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AB2CNQg9hGg/hKQg9hJgyhA");
		this.shape_132.setTransform(67,106.9);

		this.shape_133 = new cjs.Shape();
		this.shape_133.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("ACRCxQg9hGg/hLQhgh0hFhc");
		this.shape_133.setTransform(64.3,103.3);

		this.shape_134 = new cjs.Shape();
		this.shape_134.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("ACrDVQg9hGg/hLQiIikhRh0");
		this.shape_134.setTransform(61.6,99.7);

		this.shape_135 = new cjs.Shape();
		this.shape_135.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("ADBD1Qg9hGhAhLQiwjUhUiE");
		this.shape_135.setTransform(59.5,96.6);

		this.shape_136 = new cjs.Shape();
		this.shape_136.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("ADNEeQg9hGg/hLQiwjUhUiDQgZgoAAgr");
		this.shape_136.setTransform(58.3,92.4);

		this.shape_137 = new cjs.Shape();
		this.shape_137.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("ADNFJQg9hFg/hMQiwjThUiEQgZgnAAgrQAAgzAhgk");
		this.shape_137.setTransform(58.3,88.1);

		this.shape_138 = new cjs.Shape();
		this.shape_138.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("ADNFdQg9hFg/hMQiwjThUiEQgZgnAAgrQAAg2AmgmQAcgcAkgH");
		this.shape_138.setTransform(58.3,86.1);

		this.shape_139 = new cjs.Shape();
		this.shape_139.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("ADNFfQg9hGg/hLQiwjUhUiDQgZgoAAgrQAAg2AmgmQAmgmA2AAQAaAAAVAJ");
		this.shape_139.setTransform(58.3,85.9);

		this.shape_140 = new cjs.Shape();
		this.shape_140.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("ADNFfQg9hGg/hLQiwjUhUiDQgZgoAAgrQAAg2AmgmQAmgmA2AAQA2AAAlAmQAHAHAJAMQAEAGAFAG");
		this.shape_140.setTransform(58.3,85.9);

		this.shape_141 = new cjs.Shape();
		this.shape_141.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("ADNFfQg9hGg/hLQiwjUhUiDQgZgoAAgrQAAg2AmgmQAmgmA2AAQA2AAAlAmQAHAHAJAMQAjAvAlAu");
		this.shape_141.setTransform(58.3,85.9);

		this.shape_142 = new cjs.Shape();
		this.shape_142.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("ADNFfQg9hGg/hLQiwjUhUiDQgZgoAAgrQAAg2AmgmQAmgmA2AAQA2AAAlAmQAHAHAJAMQA8BQBBBM");
		this.shape_142.setTransform(58.3,85.9);

		this.shape_143 = new cjs.Shape();
		this.shape_143.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("ADKFfQg9hGg/hLQiwjUhUiDQgZgoAAgrQAAg2AmgmQAmgmA2AAQA2AAAlAmQAHAHAJAMQBVBxBdBo");
		this.shape_143.setTransform(58.6,85.9);

		this.shape_144 = new cjs.Shape();
		this.shape_144.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("ACrFfQg9hGg/hLQiwjUhUiDQgZgoAAgrQAAg2AmgmQAngmA1AAQA2AAAmAmQAHAHAJAMQBvCVCACH");
		this.shape_144.setTransform(61.6,85.9);

		this.shape_145 = new cjs.Shape();
		this.shape_145.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("ACOFfQg9hGg/hLQiwjUhUiDQgZgoAAgrQAAg2AmgmQAngmA1AAQA2AAAmAmQAHAHAJAMQCFCyCcCdQAEAEAEAE");
		this.shape_145.setTransform(64.5,85.9);

		this.shape_146 = new cjs.Shape();
		this.shape_146.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AB7FfQg8hGg/hLQixjUhUiDQgZgoAAgrQAAg2AmgmQAngmA1AAQA2AAAmAmQAHAHAJAMQCFCyCcCdQAXAXAWAW");
		this.shape_146.setTransform(66.4,85.9);

		this.shape_147 = new cjs.Shape();
		this.shape_147.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("ABuFfQg9hGg+hLQixjUhUiDQgZgoAAgrQAAg2AmgmQAngmA1AAQA2AAAmAmQAHAHAJAMQCFCyCcCdQAjAkAlAj");
		this.shape_147.setTransform(67.7,85.9);

		this.shape_148 = new cjs.Shape();
		this.shape_148.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("ABjFfQg9hGg+hLQixjUhUiDQgZgoAAgrQAAg2AmgmQAngmA1AAQA2AAAmAmQAHAHAJAMQCFCyCcCdQAuAvAwAt");
		this.shape_148.setTransform(68.9,85.9);

		this.shape_149 = new cjs.Shape();
		this.shape_149.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("ABcFfQg9hGg+hLQixjUhUiDQgZgoAAgrQAAg2AmgmQAngmA1AAQA2AAAmAmQAHAHAJAMQCFCyCcCdQA0A1A4A0");
		this.shape_149.setTransform(69.5,85.9);

		this.shape_150 = new cjs.Shape();
		this.shape_150.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("ABZFfQg9hGg+hLQixjUhUiDQgZgoAAgrQAAg2AmgmQAmgmA2AAQA2AAAmAmQAHAHAJAMQCFCyCcCdQA3A4A7A3");
		this.shape_150.setTransform(69.9,85.9);

		var maskedShapeInstanceList = [this.shape_123,this.shape_124,this.shape_125,this.shape_126,this.shape_127,this.shape_128,this.shape_129,this.shape_130,this.shape_131,this.shape_132,this.shape_133,this.shape_134,this.shape_135,this.shape_136,this.shape_137,this.shape_138,this.shape_139,this.shape_140,this.shape_141,this.shape_142,this.shape_143,this.shape_144,this.shape_145,this.shape_146,this.shape_147,this.shape_148,this.shape_149,this.shape_150];

		for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
			maskedShapeInstanceList[shapedInstanceItr].mask = mask;
		}

		this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape_123}]},67).to({state:[{t:this.shape_124}]},1).to({state:[{t:this.shape_125}]},1).to({state:[{t:this.shape_126}]},1).to({state:[{t:this.shape_127}]},1).to({state:[{t:this.shape_128}]},1).to({state:[{t:this.shape_129}]},1).to({state:[{t:this.shape_130}]},1).to({state:[{t:this.shape_131}]},1).to({state:[{t:this.shape_132}]},1).to({state:[{t:this.shape_133}]},1).to({state:[{t:this.shape_134}]},1).to({state:[{t:this.shape_135}]},1).to({state:[{t:this.shape_136}]},1).to({state:[{t:this.shape_137}]},1).to({state:[{t:this.shape_138}]},1).to({state:[{t:this.shape_139}]},1).to({state:[{t:this.shape_140}]},1).to({state:[{t:this.shape_141}]},1).to({state:[{t:this.shape_142}]},1).to({state:[{t:this.shape_143}]},1).to({state:[{t:this.shape_144}]},1).to({state:[{t:this.shape_145}]},1).to({state:[{t:this.shape_146}]},1).to({state:[{t:this.shape_147}]},1).to({state:[{t:this.shape_148}]},1).to({state:[{t:this.shape_149}]},1).to({state:[{t:this.shape_150}]},1).wait(31));

		// Layer 10
		this.shape_151 = new cjs.Shape();
		this.shape_151.graphics.f().s("rgba(137,157,213,0.329)").ss(8,1,1,3,true).p("AAAAAQAAAAABAB");
		this.shape_151.setTransform(49.9,63.5);

		this.shape_152 = new cjs.Shape();
		this.shape_152.graphics.f().s("rgba(137,157,213,0.659)").ss(8,1,1,3,true).p("AgDgDQADADAEAF");
		this.shape_152.setTransform(50.2,63.8);

		this.shape_153 = new cjs.Shape();
		this.shape_153.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AgGgIQAGAIAHAK");
		this.shape_153.setTransform(50.5,64.3);

		this.shape_154 = new cjs.Shape();
		this.shape_154.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AgNgRQANARAOAS");
		this.shape_154.setTransform(51.2,65.2);

		this.shape_155 = new cjs.Shape();
		this.shape_155.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AgXgdQAXAdAYAe");
		this.shape_155.setTransform(52.2,66.4);

		this.shape_156 = new cjs.Shape();
		this.shape_156.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AgigrQAiArAkAt");
		this.shape_156.setTransform(53.4,67.8);

		this.shape_157 = new cjs.Shape();
		this.shape_157.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("Agxg9QAxA+AyA9");
		this.shape_157.setTransform(54.8,69.6);

		this.shape_158 = new cjs.Shape();
		this.shape_158.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AhChSQBBBTBEBS");
		this.shape_158.setTransform(56.5,71.6);

		this.shape_159 = new cjs.Shape();
		this.shape_159.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AhXhqQBVBsBaBq");
		this.shape_159.setTransform(58.6,74.1);

		this.shape_160 = new cjs.Shape();
		this.shape_160.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AhyiJQBvCNB2CG");
		this.shape_160.setTransform(61.3,77.2);

		this.shape_161 = new cjs.Shape();
		this.shape_161.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AiNimQCHCsCUCh");
		this.shape_161.setTransform(64,80.1);

		this.shape_162 = new cjs.Shape();
		this.shape_162.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AipjFQChDNCyC+");
		this.shape_162.setTransform(66.8,83.2);

		this.shape_163 = new cjs.Shape();
		this.shape_163.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("Ai9jaQCyDkDJDQ");
		this.shape_163.setTransform(68.8,85.2);

		this.shape_164 = new cjs.Shape();
		this.shape_164.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AjKjnQC+DzDXDc");
		this.shape_164.setTransform(70.1,86.5);

		this.shape_165 = new cjs.Shape();
		this.shape_165.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AjRjuQDED6DfDj");
		this.shape_165.setTransform(70.8,87.3);

		this.shape_166 = new cjs.Shape();
		this.shape_166.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AjUjxQDHD+DiDl");
		this.shape_166.setTransform(71.1,87.5);

		var maskedShapeInstanceList = [this.shape_151,this.shape_152,this.shape_153,this.shape_154,this.shape_155,this.shape_156,this.shape_157,this.shape_158,this.shape_159,this.shape_160,this.shape_161,this.shape_162,this.shape_163,this.shape_164,this.shape_165,this.shape_166];

		for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
			maskedShapeInstanceList[shapedInstanceItr].mask = mask;
		}

		this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape_151}]},80).to({state:[{t:this.shape_152}]},1).to({state:[{t:this.shape_153}]},1).to({state:[{t:this.shape_154}]},1).to({state:[{t:this.shape_155}]},1).to({state:[{t:this.shape_156}]},1).to({state:[{t:this.shape_157}]},1).to({state:[{t:this.shape_158}]},1).to({state:[{t:this.shape_159}]},1).to({state:[{t:this.shape_160}]},1).to({state:[{t:this.shape_161}]},1).to({state:[{t:this.shape_162}]},1).to({state:[{t:this.shape_163}]},1).to({state:[{t:this.shape_164}]},1).to({state:[{t:this.shape_165}]},1).to({state:[{t:this.shape_166}]},1).wait(30));

		// Layer 11
		this.shape_167 = new cjs.Shape();
		this.shape_167.graphics.f().s("rgba(137,157,213,0.329)").ss(8,1,1,3,true).p("AABAAQgBAAgBAB");
		this.shape_167.setTransform(22.2,122.4);

		this.shape_168 = new cjs.Shape();
		this.shape_168.graphics.f().s("rgba(137,157,213,0.659)").ss(8,1,1,3,true).p("AAGgDQgGADgFAE");
		this.shape_168.setTransform(22.7,122.1);

		this.shape_169 = new cjs.Shape();
		this.shape_169.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AALgHQgLAHgLAI");
		this.shape_169.setTransform(23.2,121.7);

		this.shape_170 = new cjs.Shape();
		this.shape_170.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AAUgNQgTAOgUAN");
		this.shape_170.setTransform(24.1,121.1);

		this.shape_171 = new cjs.Shape();
		this.shape_171.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AAfgXQgeAbggAU");
		this.shape_171.setTransform(25.2,120.1);

		this.shape_172 = new cjs.Shape();
		this.shape_172.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AAsgjQgFAFgEAEQgkAkgqAa");
		this.shape_172.setTransform(26.4,118.9);

		this.shape_173 = new cjs.Shape();
		this.shape_173.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AA4gxQgPATgTASQgkAlgpAZ");
		this.shape_173.setTransform(27.7,117.5);

		this.shape_174 = new cjs.Shape();
		this.shape_174.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("ABIhJQgaAtgoAnQgkAlgpAZ");
		this.shape_174.setTransform(29.3,115.2);

		this.shape_175 = new cjs.Shape();
		this.shape_175.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("ABUhfQgeBHg6A5QglAlgpAa");
		this.shape_175.setTransform(30.4,112.9);

		this.shape_176 = new cjs.Shape();
		this.shape_176.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("ABahzQgbBfhKBJQglAlgqAa");
		this.shape_176.setTransform(31.1,110.9);

		this.shape_177 = new cjs.Shape();
		this.shape_177.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("ABeiCQgXBxhWBVQglAlgpAa");
		this.shape_177.setTransform(31.5,109.4);

		this.shape_178 = new cjs.Shape();
		this.shape_178.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("ABgiMQgSB9hfBeQgkAlgqAa");
		this.shape_178.setTransform(31.7,108.4);

		this.shape_179 = new cjs.Shape();
		this.shape_179.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("ABgiQQgRCChgBgQglAlgqAa");
		this.shape_179.setTransform(31.7,108);

		var maskedShapeInstanceList = [this.shape_167,this.shape_168,this.shape_169,this.shape_170,this.shape_171,this.shape_172,this.shape_173,this.shape_174,this.shape_175,this.shape_176,this.shape_177,this.shape_178,this.shape_179];

		for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
			maskedShapeInstanceList[shapedInstanceItr].mask = mask;
		}

		this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape_167}]},90).to({state:[{t:this.shape_168}]},1).to({state:[{t:this.shape_169}]},1).to({state:[{t:this.shape_170}]},1).to({state:[{t:this.shape_171}]},1).to({state:[{t:this.shape_172}]},1).to({state:[{t:this.shape_173}]},1).to({state:[{t:this.shape_174}]},1).to({state:[{t:this.shape_175}]},1).to({state:[{t:this.shape_176}]},1).to({state:[{t:this.shape_177}]},1).to({state:[{t:this.shape_178}]},1).to({state:[{t:this.shape_179}]},1).wait(23));

		// Layer 1
		this.shape_180 = new cjs.Shape();
		this.shape_180.graphics.f().s("rgba(137,157,213,0.329)").ss(8,1,1,3,true).p("AAAACQAAgCABgB");
		this.shape_180.setTransform(37.1,127.4);

		this.shape_181 = new cjs.Shape();
		this.shape_181.graphics.f().s("rgba(137,157,213,0.659)").ss(8,1,1,3,true).p("AgEAIQAEgIAFgH");
		this.shape_181.setTransform(37.4,126.8);

		this.shape_182 = new cjs.Shape();
		this.shape_182.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AgIAOQAIgOAJgO");
		this.shape_182.setTransform(37.8,126.1);

		this.shape_183 = new cjs.Shape();
		this.shape_183.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AgNAXQANgYAOgV");
		this.shape_183.setTransform(38.3,125.3);

		this.shape_184 = new cjs.Shape();
		this.shape_184.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AgWAjQAXgnAWge");
		this.shape_184.setTransform(39.2,124);

		this.shape_185 = new cjs.Shape();
		this.shape_185.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AgjA0QAlhCAigl");
		this.shape_185.setTransform(40.6,122.3);

		this.shape_186 = new cjs.Shape();
		this.shape_186.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("Ag3BGQA9hrAygg");
		this.shape_186.setTransform(42.5,120.6);

		this.shape_187 = new cjs.Shape();
		this.shape_187.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AhSBMQBSiPA9gIQALgBAMAD");
		this.shape_187.setTransform(45.3,119.9);

		this.shape_188 = new cjs.Shape();
		this.shape_188.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AhoBMQBSiPA9gIQAggEAiAh");
		this.shape_188.setTransform(47.5,119.9);

		this.shape_189 = new cjs.Shape();
		this.shape_189.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("Ah6BMQBTiPA8gIQAwgGA2BO");
		this.shape_189.setTransform(49.3,119.9);

		this.shape_190 = new cjs.Shape();
		this.shape_190.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AiEBMQBTiPA8gIQA5gHBBBt");
		this.shape_190.setTransform(50.3,119.9);

		this.shape_191 = new cjs.Shape();
		this.shape_191.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AiHBMQBTiPA8gIQA8gIBEB5");
		this.shape_191.setTransform(50.6,119.9);

		this.shape_192 = new cjs.Shape();
		this.shape_192.graphics.f().s("#899DD5").ss(8,1,1,3,true).p("AiJBMQBTiPA8gIQA+gIBGCA");
		this.shape_192.setTransform(50.8,119.9);

		var maskedShapeInstanceList = [this.shape_180,this.shape_181,this.shape_182,this.shape_183,this.shape_184,this.shape_185,this.shape_186,this.shape_187,this.shape_188,this.shape_189,this.shape_190,this.shape_191,this.shape_192];

		for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
			maskedShapeInstanceList[shapedInstanceItr].mask = mask;
		}

		this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape_180}]},101).to({state:[{t:this.shape_181}]},1).to({state:[{t:this.shape_182}]},1).to({state:[{t:this.shape_183}]},1).to({state:[{t:this.shape_184}]},1).to({state:[{t:this.shape_185}]},1).to({state:[{t:this.shape_186}]},1).to({state:[{t:this.shape_187}]},1).to({state:[{t:this.shape_188}]},1).to({state:[{t:this.shape_189}]},1).to({state:[{t:this.shape_190}]},1).to({state:[{t:this.shape_191}]},1).to({state:[{t:this.shape_192}]},1).wait(12));

		// Layer 4
		this.shape_193 = new cjs.Shape();
		this.shape_193.graphics.f("#353E59").s().p("Ai9KPQgHgEgCgIQgCgIAEgHQBaidBFgFQBIgNBPCQQAEAIgCAIQgCAHgIAEQgHAEgIgCQgIgCgEgIQg+hxgxADQg1AJhNCFQgEAHgIACIgFABQgFAAgFgDgAlNJfQgHgCgFgHQgEgHACgIQACgIAHgFQAngYAjgjIABAAQBchcAQh8QABgIAHgFQAHgFAIABQAIABAFAHQAFAGgBAIQgSCJhmBmIAAAAQgnAngrAaQgFADgGAAIgFAAgADtJQQgIAAgGgGQg9hGg/hMQixjWhViEIAAAAQgcgtAAgwQAAg+AsgrIAAAAQAtgsA9AAQA+AAArAsQAIAHAKAOQCFCvCbCeQA3A3A7A3QAGAGABAIQAAAIgGAGQgFAGgJABQgIAAgGgFQg8g4g3g4QidigiHixIgOgRQgggggtAAQgtAAghAgIAAAAQggAgAAAtQAAAlAWAjIAAAAQBUCCCuDUQA/BLA9BFQAGAGgBAJQAAAIgHAFQgFAFgIAAIgBAAgAF2HzQgIAAgGgGQjkjmjGj/QgFgHABgHQABgIAGgFQAHgFAIABQAIABAFAHQDFD8DiDkQAGAGAAAIQAAAJgGAGQgGAFgIAAIAAAAgAmvHoQgHgDgDgIQgDgIADgHQAEgIAHgDQAwgSAmgnIAAAAQBKhJAAhnQAAgvgWg6QgYhEAAgsQAAhxBQhRIABAAQBRhQBxAAQBxAABQBQQAQAQAHAIIgBAAQB9CQCYCPQA1AyA6A1QAHAFAAAJQABAIgGAGQgGAGgIABQgIAAgGgFQg7g2g1gyQiaiSh+iQIAAgBIgUgUQhFhFhgAAQhhAAhFBEIAAABQhFBFAABgQAAAnAWA8QAYBBAAA1QAAB3hWBVIAAABQgsAtg3AVIgHABQgEAAgFgCgAnuFvQgHgEgDgHQgDgIADgIQADgHAIgDQAZgKAVgVIAAAAQAogoAAg3QgBgTgNgpIAAAAQgZhPAAhAQAAimB2h4IABAAQB3h2CnAAQBzAABbA8QA/ApBZBsIAAAAQAoAvA3A5IAAAAQAnAoA+AuQAHAEABAIQACAIgFAHQgFAHgIABQgIABgHgFQhCgvgpgqIAAAAQg4g6gpgxIAAAAQhUhlg7gnQhRg2hnAAQiXAAhrBqIAAABQhrBrAACWQAAA7AXBIIAAAAQAQAxAAAXQAABIg0AzIAAAAQgbAbghANIgHABQgEAAgEgBgAoCDmQgIgDgEgIQgehCgKhLQgBgIAFgHQAFgGAIgBQAJgCAGAGQAHAFABAIQAJBFAcA9QADAHgDAIQgCAIgIADQgEACgEAAIgHgBgAokgdQgJAAgGgGQgFgGAAgIIAAgKIAAAAQATi0CFiGIAAAAQCcibDbAAQC6AACNBxQAGAFABAIQABAIgFAHQgFAGgJABQgIABgGgFQiChoisAAQjKAAiRCPIAAAAQh6B8gSCmIAAABIAAAFQAAAIgGAGQgGAGgIAAIAAAAgAHdinQgJAAgGgGIiHiJQgGgGAAgIQAAgIAGgGQAGgGAIAAQAJAAAFAGICICJQAGAGAAAIQAAAJgGAGQgGAFgIAAIAAAAgAGBm9Qiyisj3AAQj3AAiyCpQgGAFgIAAQgJAAgFgGQgGgGAAgIQAAgJAGgFQC+i0EHAAQEHAAC+C3QAGAGAAAIQAAAIgFAGQgGAGgIAAIgBAAQgIAAgGgFg");
		this.shape_193.setTransform(54.9,63.8);

		this.timeline.addTween(cjs.Tween.get(this.shape_193).wait(125));

	}).prototype = p = new cjs.MovieClip();
	p.nominalBounds = new cjs.Rectangle(-2,-2,113.9,131.6);


	(lib.circle = function(mode,startPosition,loop) {
		this.initialize(mode,startPosition,loop,{});

		// Layer 2 (mask)
		var mask = new cjs.Shape();
		mask._off = true;
		mask.graphics.p("AvdRjQmamaAApEQAApDGamaQGambJDAAQJDAAGaGbQGbGaAAJDQAAJEmbGaQhQBPhWBBIgXggQBUg+BOhOQGOmOAAo0QAAoymOmOQmQmPoygBQozABmOGPQmOGOAAIyQAAI0GOGOQBOBOBUA+IgXAhQhXhChQhPg");
		mask.setTransform(140,126.8);

		// Layer 3
		this.instance = new lib.Tween1("synched",0);
		this.instance.parent = this;
		this.instance.setTransform(140,140,1,0.743,35.5,0,0,-35.5,-115.5);
		this.instance.alpha = 0.199;

		var maskedShapeInstanceList = [this.instance];

		for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
			maskedShapeInstanceList[shapedInstanceItr].mask = mask;
		}

		this.timeline.addTween(cjs.Tween.get(this.instance).to({scaleX:1.02,scaleY:0.74,rotation:37.1,alpha:0.219},3).to({scaleX:1.07,scaleY:0.74,rotation:41.6,x:140.1,alpha:0.289},3).to({regY:-115.4,scaleX:1.58,scaleY:0.71,rotation:83.2,y:140.1,alpha:0.898},13).to({regY:-115.5,scaleX:1.64,scaleY:0.71,rotation:88.4,alpha:0.98},4).to({scaleX:1.67,scaleY:0.71,rotation:90,y:140.2,alpha:1},4).to({regX:-35.6,scaleX:1.68,scaleY:0.71,rotation:92.3,y:140},3).to({scaleX:1.73,rotation:99.3},3).to({scaleX:2.19,rotation:169.2,y:139.9},16).to({regY:-115.6,scaleX:2.24,rotation:177.5,x:140,y:140.1},5).to({regX:-35.5,regY:-115.4,scaleX:2.26,scaleY:0.71,rotation:180},5).to({scaleX:2.26,scaleY:0.71,rotation:182.3,x:140.1},3).to({regY:-115.5,rotation:189.3,x:140},3).to({regY:-115.4,scaleX:2.26,rotation:259.2,x:139.9},17).to({scaleX:2.26,rotation:267.5,y:140.2},4).to({scaleX:2.26,scaleY:0.71,rotation:270},4).to({regY:-115.5,scaleX:2.26,scaleY:0.71,rotation:270.8,y:140.3},3).to({regY:-115.4,rotation:273.3,x:139.8,y:140.2},3).to({scaleX:2.26,rotation:280.3,y:140.3},3).to({regY:-115.5,scaleX:2.26,scaleY:0.7,rotation:315.4,y:140.1},16).to({scaleX:2.25,rotation:321.4,x:139.7},3).to({rotation:323.7,y:140.2},3).to({regX:-35.4,regY:-115.4,scaleX:2.26,scaleY:0.71,rotation:324.4,x:139.9,y:140},3).wait(1));

		// Layer 4
		this.shape = new cjs.Shape();
		this.shape.graphics.f("#0CB754").s().p("AsupOIZdgBIAASeI5dABg");
		this.shape.setTransform(58.6,199.3);

		this.shape_1 = new cjs.Shape();
		this.shape_1.graphics.f("#0CB754").s().p("Asu19IZbAAIAAZcIACAAIAASfI5dAAg");
		this.shape_1.setTransform(58.6,117.9);

		this.shape_2 = new cjs.Shape();
		this.shape_2.graphics.f("#0CB754").s().p("A5b19MAy3AAAIAAZcI5aAAIAASfI5dAAg");
		this.shape_2.setTransform(139.9,117.9);

		var maskedShapeInstanceList = [this.shape,this.shape_1,this.shape_2];

		for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
			maskedShapeInstanceList[shapedInstanceItr].mask = mask;
		}

		this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape}]},27).to({state:[{t:this.shape_1}]},32).to({state:[{t:this.shape_2}]},31).wait(35));

		// Layer 1
		this.shape_3 = new cjs.Shape();
		this.shape_3.graphics.f("#353E59").s().p("AvdRjQmamaAApEQAApDGamaQGambJDAAQJDAAGaGbQGbGaAAJDQAAJEmbGaQhQBPhWBBIgXggQBUg+BOhOQGOmOAAo0QAAoymOmOQmQmPoygBQozABmOGPQmOGOAAIyQAAI0GOGOQBOBOBUA+IgXAhQhXhChQhPg");
		this.shape_3.setTransform(140,126.8);

		this.timeline.addTween(cjs.Tween.get(this.shape_3).wait(125));

	}).prototype = p = new cjs.MovieClip();
	p.nominalBounds = new cjs.Rectangle(0,0,280,253.5);


	// stage content:
	(lib.animation = function(mode,startPosition,loop) {
		this.initialize(mode,startPosition,loop,{});

		// timeline functions:
		this.frame_124 = function() {
			var _this = this;
			/*
			Stop a Movie Clip/Video
			Stops the specified movie clip or video.
			*/
			_this.stop();
		}

		// actions tween:
		this.timeline.addTween(cjs.Tween.get(this).wait(124).call(this.frame_124).wait(1));

		// Layer 2
		this.instance = new lib.circle("synched",0);
		this.instance.parent = this;
		this.instance.setTransform(170,156.8,1,1,0,0,0,140,126.8);

		this.instance_1 = new lib.fingerprint("synched",0);
		this.instance_1.parent = this;
		this.instance_1.setTransform(170,170.1,1,1,0,0,0,54.9,63.8);

		this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).wait(125));

	}).prototype = p = new cjs.MovieClip();
	p.nominalBounds = new cjs.Rectangle(200,200,280,253.5);
	// library properties:
	lib.properties = {
		id: '64CC7631D24AC745B8BF905CF53BF115',
		width: 340,
		height: 340,
		fps: 25,
		color: "#2C354C",
		opacity: 1.00,
		manifest: [],
		preloads: []
	};



	// bootstrap callback support:

	(lib.Stage = function(canvas) {
		createjs.Stage.call(this, canvas);
	}).prototype = p = new createjs.Stage();

	p.setAutoPlay = function(autoPlay) {
		this.tickEnabled = autoPlay;
	}
	p.play = function() { this.tickEnabled = true; this.getChildAt(0).gotoAndPlay(this.getTimelinePosition()) }
	p.stop = function(ms) { if(ms) this.seek(ms); this.tickEnabled = false; }
	p.seek = function(ms) { this.tickEnabled = true; this.getChildAt(0).gotoAndStop(lib.properties.fps * ms / 1000); }
	p.getDuration = function() { return this.getChildAt(0).totalFrames / lib.properties.fps * 1000; }

	p.getTimelinePosition = function() { return this.getChildAt(0).currentFrame / lib.properties.fps * 1000; }

	an.bootcompsLoaded = an.bootcompsLoaded || [];
	if(!an.bootstrapListeners) {
		an.bootstrapListeners=[];
	}

	an.bootstrapCallback=function(fnCallback) {
		an.bootstrapListeners.push(fnCallback);
		if(an.bootcompsLoaded.length > 0) {
			for(var i=0; i<an.bootcompsLoaded.length; ++i) {
				fnCallback(an.bootcompsLoaded[i]);
			}
		}
	};

	an.compositions = an.compositions || {};
	an.compositions['64CC7631D24AC745B8BF905CF53BF115'] = {
		getStage: function() { return exportRoot.getStage(); },
		getLibrary: function() { return lib; },
		getSpriteSheet: function() { return ss; },
		getImages: function() { return img; }
	};

	an.compositionLoaded = function(id) {
		an.bootcompsLoaded.push(id);
		for(var j=0; j<an.bootstrapListeners.length; j++) {
			an.bootstrapListeners[j](id);
		}
	}

	an.getComposition = function(id) {
		return an.compositions[id];
	}





	// From HTML file
	var canvas, stage, exportRoot, anim_container, dom_overlay_container, fnStartAnimation;
	window.initScanPopupLoaderAnimation = function() {
		canvas = document.getElementById("canvas");
		anim_container = document.getElementById("animation_container");
		dom_overlay_container = document.getElementById("dom_overlay_container");
		var comp=AdobeAn.getComposition("64CC7631D24AC745B8BF905CF53BF115");
		var lib=comp.getLibrary();
		handleComplete({},comp);
	}
	function handleComplete(evt,comp) {
		//This function is always called, irrespective of the content. You can use the variable "stage" after it is created in token create_stage.
		var lib=comp.getLibrary();
		var ss=comp.getSpriteSheet();
		exportRoot = new lib.animation();
		stage = new lib.Stage(canvas);
		//Registers the "tick" event listener.
		fnStartAnimation = function() {
			stage.addChild(exportRoot);
			createjs.Ticker.setFPS(lib.properties.fps);
			createjs.Ticker.addEventListener("tick", stage);
		}
		//Code to support hidpi screens and responsive scaling.
		function makeResponsive(isResp, respDim, isScale, scaleType) {
			var lastW, lastH, lastS=1;
			window.addEventListener('resize', resizeCanvas);
			resizeCanvas();
			function resizeCanvas() {
				var w = lib.properties.width, h = lib.properties.height;
				var iw = window.innerWidth, ih=window.innerHeight;
				var pRatio = window.devicePixelRatio || 1, xRatio=iw/w, yRatio=ih/h, sRatio=1;
				if(isResp) {
					if((respDim=='width'&&lastW==iw) || (respDim=='height'&&lastH==ih)) {
						sRatio = lastS;
					}
					else if(!isScale) {
						if(iw<w || ih<h)
							sRatio = Math.min(xRatio, yRatio);
					}
					else if(scaleType==1) {
						sRatio = Math.min(xRatio, yRatio);
					}
					else if(scaleType==2) {
						sRatio = Math.max(xRatio, yRatio);
					}
				}
				canvas.width = w*pRatio*sRatio;
				canvas.height = h*pRatio*sRatio;
				canvas.style.width = dom_overlay_container.style.width = anim_container.style.width =  w*sRatio+'px';
				canvas.style.height = anim_container.style.height = dom_overlay_container.style.height = h*sRatio+'px';
				stage.scaleX = pRatio*sRatio;
				stage.scaleY = pRatio*sRatio;
				lastW = iw; lastH = ih; lastS = sRatio;
				stage.tickOnUpdate = false;
				stage.update();
				stage.tickOnUpdate = true;
			}
		}
		makeResponsive(false,'both',false,1);
		AdobeAn.compositionLoaded(lib.properties.id);
		fnStartAnimation();
	}
		// /From HTML file
});


/* /Custom createJS animation script */

// #trackers section animation
(function() {
	'use strict';
	var $play = document.querySelector('[data-animation="play"]');
	var $controls = document.querySelectorAll('[data-animation="control"]');
	var controls = $controls.length;
	var $animation = document.querySelector('[data-animation="animation"]');
	var $svg = $animation.querySelector('svg');
	var cache = {
	step: 0
	};
	var config = {};
	config.stepDuration = 300;
	config.animationDuration = config.stepDuration * controls; // Use https://jirimaha.com/avast/avg/walkway.min.js
	// which is minified version of https://github.com/ConnorAtherton/walkway/pull/51
	// which supports .pause() method

	var walkway = new Walkway({
	selector: '#fingerprint-step',
	duration: config.animationDuration.toString(),
	// https://github.com/AndrewRayCode/easing-utils/blob/master/src/easing.js
	easing: function easing(t) {
		return -0.5 * (Math.cos(Math.PI * t) - 1);
	}
	});

	var playStep = function playStep() {
	$play.removeEventListener('click', playStep, false);
	$play.classList.add('done');
	$controls[cache.step].classList.add('done');
	walkway.draw();
	cache.step += 1;
	window.setTimeout(function () {
		walkway.pause();

		if (cache.step < controls) {
		$play.addEventListener('click', playStep, false);
		$play.classList.remove('done');
		}

		if (cache.step === controls) {
		$play.classList.add('complete');
		}
	}, config.stepDuration);
	};

	$play.addEventListener('click', playStep, false);
})();
// /#trackers section animation


// carousel controllers
if ($('.slider-sliderSliNotiSecSm').length > 0) {
	var sliderInfNotiSecMed =  document.querySelectorAll('.slider-sliderSliNotiSecSm').forEach(
		function(slider, index){
			tns({
			"container": slider,
			"controlsContainer": document.querySelectorAll('.slider-sliderSliNotiSecSm-controls')[index],
			"preventScrollOnTouch": "force",
			"controlsPosition": "bottom",
			"controls": false,
			"navPosition": "bottom",
			"mouseDrag": true,
			"speed": 400,
			"center": false,
			"slideBy": 1,
			"fixedWidth": 250,
			"gutter": 16,
			"loop": false,
			"responsive": {
				"768": {
					"slideBy": 1,
					"controls": false,
					"fixedWidth": 316,
					"gutter": 32
				},
				"1280": {
					"slideBy": 1,
					"controls": true,
					"fixedWidth": 316,
					"gutter": 64
				},
				"1600": {
					"slideBy": 1,
					"controls": true,
					"fixedWidth": 316,
					"gutter": 64
				}
			}
			})
		})
}

if ($('.slider-sliderSliNotiSecSm-hybrid').length > 0) {
	var sliderInfNotiSecMed =  document.querySelectorAll('.slider-sliderSliNotiSecSm-hybrid').forEach(
		function(slider, index){
			tns({
				"container": slider,
				"controlsContainer": document.querySelectorAll('.slider-sliderSliNotiSecSm-hybrid-controls')[index],
				"preventScrollOnTouch": "force",
				"controlsPosition": "bottom",
				"controls": false,
				"navPosition": "bottom",
				"mouseDrag": true,
				"speed": 400,
				"center": false,
				"slideBy": 1,
				"fixedWidth": 270,
				"gutter": 16,
				"loop": false,
				"responsive": {
					"768": {
						"slideBy": 1,
						"controls": false,
						"fixedWidth": 290,
						"gutter": 32
					},
					"1280": {
						"slideBy": 1,
						"controls": true,
						"fixedWidth": 290,
						"gutter": 64
					},
					"1600": {
						"slideBy": 1,
						"controls": true,
						"fixedWidth": 290,
						"gutter": 64
					}
				}
			})
		})
}
